(function () {
    'use strict';

    angular
        .module('visor.piscina.terceiro.passo',
            [
                'visor.piscina.terceiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.terceiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('visor-piscina.terceiro-passo', {
                url: '/terceiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/visor-piscina/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html',
                        controller: 'VisorPiscinaTerceiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.terceiro.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('VisorPiscinaTerceiroPassoController', VisorPiscinaTerceiroPassoController);

    /** @ngInject */
    function VisorPiscinaTerceiroPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.VisorPiscinaModel;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.imprimir = function () {
            window.print();
        };

        function init() {
        }
        //init();
    }
})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.segundo.passo',
            [
                //'dados.apoio',
                //'dados.edificacao',
                //'dados.vidro'
                'visor.piscina.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('visor-piscina.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/visor-piscina/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'VisorPiscinaSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.segundo.passo.controller', ['calculo.factory'])
        .controller('VisorPiscinaSegundoPassoController', VisorPiscinaSegundoPassoController);

    /** @ngInject */
    function VisorPiscinaSegundoPassoController($scope, $state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, CalculoFactory) {

        var vm = this;
        vm.model = CalculoEspessuraService.VisorPiscinaModel;
        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
        SelecaoObjetivoService.podeAlterar = false;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.calcular = function () {
            if (!vm.validarDados()){
                return;
            }

            LoadingService.loader.exibir();

            var modelo = {
                AlturaVidro: vm.model.VidroAltura,
                LarguraVidro: vm.model.VidroLargura,
                AlturaAgua: vm.model.AguaAltura,
                TipoCalculoId: vm.model.TipoVisor.Id,
                TipoVidroId: 2,
                Nome: vm.model.Nome,
                Telefone: vm.model.Telefone,
                Empresa: vm.model.Empresa,
                Fax: vm.model.Fax,
                Obra: vm.model.Obra,
                Email: vm.model.Email
            };

            CalculoFactory.calcularPiscinaAquario(modelo)
                .then(function (resposta) {
                    vm.retorno = resposta;

                    vm.model.RelatorioFinal = resposta;

                    LoadingService.loader.esconder();
                    vm.irPassoPosterior();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        };

        vm.validarDados = function (){
            if (!vm.model.Nome) {
                toastr.warning('Nome não informado!', 'Nome do Solicitante');
                return false;
            }
            else if(!vm.model.Telefone){
                toastr.warning('Telefone não informado!', 'Telefone do Solicitante');
                return false;
            }
            else if(!vm.model.Empresa){
                toastr.warning('Empresa não informada!', 'Empresa do Solicitante');
                return false;
            }
            else if(!vm.model.Obra){
                toastr.warning('Obra não informada!', 'Obra do Solicitante');
                return false;
            }
            else if(!vm.model.Email){
                toastr.warning('Email não informado!', 'Email do Solicitante');
                return false;
            }
            else {
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.primeiro.passo',
            [
                //'terreno.regiao.eolica',
                //'terreno.rugosidade',
                //'terreno.topografia'
                'visor.piscina.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('visor-piscina.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/visor-piscina/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'VisorPiscinaPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.primeiro.passo.controller', ['calculo.factory'])
        .controller('VisorPiscinaPrimeiroPassoController', VisorPiscinaPrimeiroPassoController);

    /** @ngInject */
    function VisorPiscinaPrimeiroPassoController($scope, $state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, CalculoFactory, LoadingService) {
        $scope.fundo4lados = true;
        var vm = this;
        vm.model = CalculoEspessuraService.VisorPiscinaModel;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        SelecaoObjetivoService.podeAlterar = true;

        // vm.sourceVisores = [
        //     {
        //         descricaoVidro: 'Fundo apoiado em 4 lados.',
        //         titulo: 'Visor Aplicado como Fundo.',
        //         imgSrc: 'assets/images/piscina/pool_tipo_1.JPG',
        //         imgSrcSelecionado: 'assets/images/piscina/vidro_selecionado_1.jpg'
        //     },
        //     {
        //         descricaoVidro: 'Apoiado em 4 lados s/ coluna de água.',
        //         titulo: 'Visor Aplicado na Vertical, apoiado em quatro lados sem coluna de água acima do vidro.',
        //         imgSrc: 'assets/images/piscina/pool_tipo_2.JPG',
        //         imgSrcSelecionado: 'assets/images/piscina/vidro_selecionado_2.jpg'
        //     },
        //     {
        //         descricaoVidro: 'Apoiado em 4 lados c/ coluna de água.',
        //         titulo: 'Visor Aplicado na Vertical, apoiado em quatro lados com coluna de água acima do vidro.',
        //         imgSrc: 'assets/images/piscina/pool_tipo_3.JPG',
        //         imgSrcSelecionado: 'assets/images/piscina/vidro_selecionado_3.jpg'
        //     },
        //     {
        //         descricaoVidro: 'Apoiado em 3 lados.',
        //         titulo: 'Visor Aplicado na Vertical, apoiado em três (com a borda superior livre).',
        //         imgSrc: 'assets/images/piscina/pool_tipo_4.JPG',
        //         imgSrcSelecionado: 'assets/images/piscina/vidro_selecionado_4.jpg'
        //     }
        // ];
        vm.sourceVisores = [];

        vm.selecionarVisor = function (paramVisor) {
            if (paramVisor.Id==3){
                $scope.fundo4lados = !$scope.fundo4lados;
            }else{
                $scope.fundo4lados = true;
            }

            
            angular.element(vm.sourceVisores).each(function (iV, visor) {
                visor.selecionado = false;
            });
            var visorSelecionado = angular.element.grep(vm.sourceVisores, function (visor) {
                return visor.Id == paramVisor.Id;
            })[0];

            visorSelecionado.selecionado = true;
            //paramVisor.selecionado = true;
        };

        vm.visorSelecionado = function () {
            return angular.element.grep(vm.sourceVisores, function (visor) {
                return visor.selecionado;
            })[0];
        };

        vm.irPassoPosterior = function () {
            if (!vm.validarDados()){
                return;
            }

            vm.model.TipoVisor = vm.visorSelecionado();
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if (!vm.visorSelecionado()){
                toastr.warning("Selecione o tipo de visor!");
                return false;
            }
            else if(!vm.model.VidroAltura || vm.model.VidroAltura <= 0){
                toastr.warning("Insira um valor válido para altura do vidro!");
                return false;
            }
            else if(!vm.model.VidroLargura || vm.model.VidroLargura <= 0){
                toastr.warning("Insira um valor válido para largura do vidro!");
                return false;
            }
            else if(vm.visorSelecionado().NecessarioAlturaAgua && (!vm.model.AguaAltura || vm.model.AguaAltura <= 0)){
                toastr.warning("Insira um valor válido para altura da água!");
                return false;
            }
            else {
                return true;
            }
        };

        function init() {
            LoadingService.loader.exibir();

            CalculoFactory.buscarTiposCalculoPiscinaAquario()
                .then(function (resultado) {
                    vm.sourceVisores = resultado;

                    if(vm.model.TipoVisor){
                        vm.selecionarVisor(vm.model.TipoVisor);
                    }

                    LoadingService.loader.esconder();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        }
        init();

    }
})();

(function () {
    'use strict';

    angular
        .module('tampo.terceiro.passo',
            [
                'tampo.terceiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('tampo.terceiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('tampo.terceiro-passo', {
                url: '/terceiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/tampo/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html',
                        controller: 'TampoTerceiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('tampo.terceiro.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('TampoTerceiroPassoController', TampoTerceiroPassoController);

    /** @ngInject */
    function TampoTerceiroPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.Tampo;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.imprimir = function () {
            window.print();
        };

        function init() {
        }
        //init();
    }
})();

(function () {
    'use strict';

    angular
        .module('tampo.segundo.passo',
            [
                'tampo.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('tampo.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('tampo.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/tampo/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'TampoSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('tampo.segundo.passo.controller', ['calculo.factory'])
        .controller('TampoSegundoPassoController', TampoSegundoPassoController);

    /** @ngInject */
    function TampoSegundoPassoController($scope, $state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, CalculoFactory) {

        var vm = this;
        vm.model = CalculoEspessuraService.Tampo;
        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
        SelecaoObjetivoService.podeAlterar = false;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.calcular = function () {
            if (!vm.validarDados()){
                return;
            }

            LoadingService.loader.exibir();

            CalculoFactory.calcularEspessuraTampo(vm.model)
                .then(function (resposta) {
                    vm.retorno = resposta;

                    vm.model.RelatorioFinal = resposta;

                    LoadingService.loader.esconder();
                    vm.irPassoPosterior();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        };

        vm.validarDados = function (){
            if (!vm.model.Nome) {
                toastr.warning('Nome não informado!', 'Nome do Solicitante');
                return false;
            }
            else if(!vm.model.Telefone){
                toastr.warning('Telefone não informado!', 'Telefone do Solicitante');
                return false;
            }
            else if(!vm.model.Empresa){
                toastr.warning('Empresa não informada!', 'Empresa do Solicitante');
                return false;
            }
            else if(!vm.model.Obra){
                toastr.warning('Obra não informada!', 'Obra do Solicitante');
                return false;
            }
            else if(!vm.model.Email){
                toastr.warning('Email não informado!', 'Email do Solicitante');
                return false;
            }
            else {
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('tampo.primeiro.passo',
            [
                'tampo.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('tampo.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('tampo.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/tampo/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'TampoPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('tampo.primeiro.passo.controller', ['calculo.factory'])
        .controller('TampoPrimeiroPassoController', TampoPrimeiroPassoController);

    /** @ngInject */
    function TampoPrimeiroPassoController($scope, $state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, VidroFactory, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.Tampo;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        SelecaoObjetivoService.podeAlterar = true;

        vm.sourceTiposVidro = [];

        vm.irPassoPosterior = function () {
            if (!vm.validarDados()){
                return;
            }

            vm.model.TipoVidroId = vm.model.tipoVidro.Id;
            vm.model.AlturaAplicacao = (vm.model.SuperficieTodaApoiada ? 0: vm.model.AlturaAplicacao);

            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if (!vm.model.tipoVidro){
                toastr.warning("Selecione o tipo de vidro!");
                return false;
            }
            else if(!vm.model.TampoRedondo && (!vm.model.Largura || vm.model.Largura <= 0)){
                toastr.warning("Insira um valor válido para largura do vidro!");
                return false;
            }
            else if(!vm.model.TampoRedondo && (!vm.model.Comprimento || vm.model.Comprimento <= 0)){
                toastr.warning("Insira um valor válido para comprimento do vidro!");
                return false;
            }
            else if(vm.model.TampoRedondo && (!vm.model.Diametro || vm.model.Diametro <= 0)){
                toastr.warning("Insira um valor válido para diametro do vidro!");
                return false;
            }
            else if(!vm.model.SuperficieTodaApoiada && (!vm.model.AlturaAplicacao || vm.model.AlturaAplicacao <= 0)){
                toastr.warning("Insira um valor válido para altura!");
                return false;
            }
            else {
                return true;
            }
        };

        function init() {
            LoadingService.loader.exibir();

            VidroFactory.buscarTiposVidrosTampo()
                .then(function (resultado) {
                    vm.sourceTiposVidro = resultado;

                    LoadingService.loader.esconder();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        }
        init();

    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.terceiro.passo',
            [
                'pressao.vento.terceiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.terceiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento.terceiro-passo', {
                url: '/terceiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/pressao-vento/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html',
                        controller: 'PressaoVentoTerceiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.terceiro.passo.controller', ['vidro.factory'])
        .controller('PressaoVentoTerceiroPassoController', PressaoVentoTerceiroPassoController);

    /** @ngInject */
    function PressaoVentoTerceiroPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, VidroFactory, toastr, LoadingService) {

        var vm = this;

        vm.sourceVidros = [];
        vm.PressaoVentoModel = CalculoEspessuraService.PressaoVentoModel;
        vm.crudRelatorioFinal = {};
        vm.bordaLivre = null;
        vm.sourceLados = [
            {descricao: '4 Lados Apoiados', valor: 4},
            {descricao: '3 Lados Apoiados', valor: 3},
            {descricao: '2 Lados Apoiados', valor: 2}
        ];
        vm.sourceBordasLivres = [
            {descricao: 'Horizontal (medida da largura)', valor: 'h'},
            {descricao: 'Vertical (medida da altura)', valor: 'v'}
        ];

        vm.aoSelecionarVidro = function(vidro){
            vm.vidroSelecionado = vidro;
        }

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            if (!vm.validarDados()){
                return;
            }

            if (vm.PressaoVentoModel.DadosVidro.Altura && vm.PressaoVentoModel.DadosVidro.Largura){
                vm.PressaoVentoModel.DadosVidro.BordaLivre = (vm.bordaLivre && vm.bordaLivre == 'h' ? vm.PressaoVentoModel.DadosVidro.Largura : vm.PressaoVentoModel.DadosVidro.Altura);
            }
            else {
                vm.bordaLivre = null;
            }

            vm.PressaoVentoModel.DadosVidro.Vidro = vm.vidroSelecionado;

            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            if (vm.bordaLivre && vm.PressaoVentoModel.DadosVidro.Altura && vm.PressaoVentoModel.DadosVidro.Largura){
                vm.PressaoVentoModel.DadosVidro.BordaLivre = (vm.bordaLivre == 'h' ? vm.PressaoVentoModel.DadosVidro.Altura : vm.PressaoVentoModel.DadosVidro.Largura);
            }
            else {
                vm.bordaLivre = null;
            }

            vm.PressaoVentoModel.DadosVidro.Vidro = vm.vidroSelecionado;

            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if (!vm.vidroSelecionado) {
                toastr.warning('Nenhuma composição de vidro selecionada!', 'Composição do Vidro');
                return false;
            }
            else if(!vm.PressaoVentoModel.DadosVidro.Altura){
                toastr.warning('Altura não informada!', 'Altura do Vidro');
                return false;
            }
            else if(!vm.PressaoVentoModel.DadosVidro.Largura){
                toastr.warning('Largura não informada!', 'Largura do Vidro');
                return false;
            }
            else if(!vm.PressaoVentoModel.DadosVidro.Apoio){
                toastr.warning('Quantidade de apoios não informado!', 'Apoio do Vidro');
                return false;
            }
            else if(!vm.bordaLivre && vm.PressaoVentoModel.DadosVidro.Apoio != 4){
                toastr.warning('Borda livre não informada!', 'Borda Livre do Vidro');
                return false;
            }
            else if(!vm.PressaoVentoModel.DadosVidro.Angulo){
                toastr.warning('Angulo não informado!', 'Angulo do Vidro');
                return false;
            }
            else if (vm.vidroSelecionado.Composicoes.length>0){
              var ok = '';
              vm.vidroSelecionado.Composicoes.forEach(function(item){
                if ((item.vidro===undefined)||(item.vidro==='')||(item.vidro===null)){
                  ok = 'ok'
                }
              });
              if (ok==='ok'){
                toastr.warning('Selecione a composição do vidro');
                return false;
              }else{
                return true;
              }
            }
            else{
              return true;
            }
        };

        function init() {
            LoadingService.loader.exibir();

          VidroFactory.buscarTiposVidro()
            .then(function (resultado){
              vm.sourceVidros = resultado;
                LoadingService.loader.esconder();
            })
              .catch(function (erro) {
                  LoadingService.loader.esconder();
              });
        }

        init();
    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.segundo.passo',
            [
                'pressao.vento.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/pressao-vento/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'PressaoVentoSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.segundo.passo.controller', [])
        .controller('PressaoVentoSegundoPassoController', PressaoVentoSegundoPassoController);

    /** @ngInject */
    function PressaoVentoSegundoPassoController($scope, $state, BarraProgressoService, RouteDefinitionService, CalculoEspessuraService, toastr) {

        var vm = this;
        vm.PressaoVentoModel = CalculoEspessuraService.PressaoVentoModel;
        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
          if (!vm.PressaoVentoModel.PressaoVentoManual){
            if(vm.PressaoVentoModel.AplicacaoVidroExterno && !vm.validarDados()) {
              return;
            }
          }
            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if (!vm.PressaoVentoModel.Edificacao.Altura) {
                toastr.warning('Campo obrigatório', 'Altura do Edifício');
                return false;
            }
            else if(!vm.PressaoVentoModel.Edificacao.MenorDimensao){
                toastr.warning('Campo obrigatório', 'Menor Dimensão do Edifício');
                return false;
            }
            else if(!vm.PressaoVentoModel.Edificacao.MaiorDimensao){
                toastr.warning('Campo obrigatório', 'Maior Dimensão do Edifício');
                return false;
            }
            else if(parseFloat(vm.PressaoVentoModel.Edificacao.MaiorDimensao)<parseFloat(vm.PressaoVentoModel.Edificacao.MenorDimensao)){
                toastr.warning('Campo obrigatório', 'As dimensões estão invertidas');
                return false;
            }
            else {
                return true;
            }
        };

        vm.Inicializar = function(){
            if(!vm.PressaoVentoModel.AplicacaoVidroExterno){
                if(RouteDefinitionService.ObterStateAnterior($state.current.name)==RouteDefinitionService.paramsStateAnterior){
                    vm.irPassoPosterior();''
                }
                else{
                    vm.irPassoAnterior();
                }
            }
            if (vm.PressaoVentoModel.PressaoVentoManual){
              vm.irPassoPosterior();
            }
        };
        vm.Inicializar();

    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.quinto.passo',
            [
                'pressao.vento.quinto.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.quinto.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento.quinto-passo', {
                url: '/quinto-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/pressao-vento/passo-a-passo/quinto-passo/quinto-passo.tpl.html',
                        controller: 'PressaoVentoQuintoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.quinto.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('PressaoVentoQuintoPassoController', PressaoVentoQuintoPassoController);

    /** @ngInject */
    function PressaoVentoQuintoPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, CalculoFactory, toastr, LoadingService) {

        var vm = this;

        vm.PressaoVentoModel = CalculoEspessuraService.PressaoVentoModel;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
        console.log(vm.PressaoVentoModel.PressaoVentoManual);
        vm.irPassoPosterior = function () {
            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.imprimir = function () {
            window.print();
        }

        vm.pegarPrimeiroNomeVidro = function(nomeVidro){
            return nomeVidro.split(' ')[0];
        };

        vm.montarExibicaoVidroAceito = function(vidro){
          if (vidro.Espessura){
              var exibicao = vm.montarNomeVidroMonolitico(vidro);

              return { Descricao: exibicao.Descricao, Espessura: exibicao.Espessura};
          }
            else {
              if (!vidro.Composicao){
                  return { Descricao: '', Espessura: 0};
              }

              var espessuraTotal = 0;
              var vidrosInternos = '';

              angular.forEach(vidro.Composicao, function (objeto, indice) {
                  var exibicao = vm.montarExibicaoVidroAceito(objeto);

                  vidrosInternos += (vidrosInternos != '' ? ' + ' + exibicao.Descricao : exibicao.Descricao);
                  espessuraTotal += exibicao.Espessura;
              });

              return { Descricao: vidro.NomeVidro.split(' ')[0] + ' ' + espessuraTotal + 'mm (' + vidrosInternos + ')', Espessura: espessuraTotal};
          }
        };

        vm.montarNomeVidroMonolitico = function(vidro){
            return { Descricao: vidro.NomeVidro + ' ' + vidro.Espessura + 'mm', Espessura: vidro.Espessura };
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.quarto.passo',
            [
                'pressao.vento.quarto.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.quarto.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento.quarto-passo', {
                url: '/quarto-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/pressao-vento/passo-a-passo/quarto-passo/quarto-passo.tpl.html',
                        controller: 'PressaoVentoQuartoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.quarto.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('PressaoVentoQuartoPassoController', PressaoVentoQuartoPassoController);

    /** @ngInject */
    function PressaoVentoQuartoPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, CalculoFactory, toastr, LoadingService) {

        var vm = this;

        vm.crudRelatorioFinal = {};
        vm.PressaoVentoModel = CalculoEspessuraService.PressaoVentoModel;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if (!vm.PressaoVentoModel.Solicitante.Nome) {
                toastr.warning('Nome não informado!', 'Nome do Solicitante');
                return false;
            }
            else if(!vm.PressaoVentoModel.Solicitante.Telefone){
                toastr.warning('Telefone não informado!', 'Telefone do Solicitante');
                return false;
            }
            else if(!vm.PressaoVentoModel.Solicitante.Empresa){
                toastr.warning('Empresa não informada!', 'Empresa do Solicitante');
                return false;
            }
            // else if(!vm.PressaoVentoModel.Solicitante.Fax){
            //     toastr.warning('Fax não informado!', 'Fax do Solicitante');
            //     return false;
            // }
            else if(!vm.PressaoVentoModel.Solicitante.Obra){
                toastr.warning('Obra não informada!', 'Obra do Solicitante');
                return false;
            }
            else if(!vm.PressaoVentoModel.Solicitante.Email){
                toastr.warning('Email não informado!', 'Email do Solicitante');
                return false;
            }
            else if (!vm.PressaoVentoModel.Solicitante.Email.match(/@/)){
              toastr.warning('Digite um e-mail correto!', 'Email do Solicitante');
              return false;
            }  else{
                return true;
            }
        };

        vm.calcular = function(){
          console.log(vm);
            if (!vm.validarDados()){
                return;
            }

            LoadingService.loader.exibir();

            var vidro = {
                VidroId: angular.copy(vm.PressaoVentoModel.DadosVidro.Vidro.Id),
                Composicao: []
            };

            angular.forEach(vm.PressaoVentoModel.DadosVidro.Vidro.Composicoes, function (comp, iComp) {
                var tempComp ={
                    VidroId: angular.copy(comp.vidro.Id),
                    Composicao: []
                };

                angular.forEach(comp.vidro.Composicoes, function (comp2, iComp2) {
                    var tempComp2 ={
                        VidroId: angular.copy(comp2.vidro.Id),
                        Composicoes: []
                    };

                    tempComp.Composicao.push(angular.copy(tempComp2));
                });

                vidro.Composicao.push(angular.copy(tempComp));
            });

            var modelo = {
                RegiaoId: (vm.PressaoVentoModel.Terreno.RegiaoEolica ? vm.PressaoVentoModel.Terreno.RegiaoEolica.Id : null),
                RugosidadeId: (vm.PressaoVentoModel.Terreno.Rugosidade ? vm.PressaoVentoModel.Terreno.Rugosidade.Id : null),
                TopografiaId: (vm.PressaoVentoModel.Terreno.Topografia ? vm.PressaoVentoModel.Terreno.Topografia.Id : null),
                PressaoVentoManual: vm.PressaoVentoModel.PressaoVento, /////campo colocado
                AlturaEdificio: vm.PressaoVentoModel.Edificacao.Altura,
                MaiorDimensao: vm.PressaoVentoModel.Edificacao.MaiorDimensao,
                MenorDimensao: vm.PressaoVentoModel.Edificacao.MenorDimensao,
                AlturaVidro: vm.PressaoVentoModel.DadosVidro.Altura,
                AplicacaoInterna: !vm.PressaoVentoModel.AplicacaoVidroExterno,
                BordaLivreVidro: vm.PressaoVentoModel.DadosVidro.BordaLivre,
                InclinacaoVidro: vm.PressaoVentoModel.DadosVidro.Angulo,
                LarguraVidro: vm.PressaoVentoModel.DadosVidro.Largura,
                QuantidadeApoios: vm.PressaoVentoModel.DadosVidro.Apoio,
                Nome: vm.PressaoVentoModel.Solicitante.Nome,
                Telefone: vm.PressaoVentoModel.Solicitante.Telefone,
                Empresa: vm.PressaoVentoModel.Solicitante.Empresa,
                Fax: vm.PressaoVentoModel.Solicitante.Fax,
                Obra: vm.PressaoVentoModel.Solicitante.Obra,
                Email: vm.PressaoVentoModel.Solicitante.Email,
                Vidro: vidro
            };

            CalculoFactory.calcularPressaoVento(modelo)
                .then(function (resposta) {
                    vm.retorno = resposta;

                    vm.PressaoVentoModel.RelatorioFinal = {
                        Nome: vm.PressaoVentoModel.Solicitante.Nome,
                        Telefone: vm.PressaoVentoModel.Solicitante.Telefone,
                        Empresa: vm.PressaoVentoModel.Solicitante.Empresa,
                        Fax: vm.PressaoVentoModel.Solicitante.Fax,
                        Obra: vm.PressaoVentoModel.Solicitante.Obra,
                        Email: vm.PressaoVentoModel.Solicitante.Email,
                        Regiao: resposta.Regiao,
                        PressaoCalculo: resposta.PressaoCalculo,
                        PressaoDinamica: resposta.PressaoDinamica,
                        PressaoVento: resposta.PressaoVento,
                        AlturaEdificio: resposta.AlturaEdificio,
                        MaiorDimensaoEdificio: resposta.MaiorDimensaoEdificio,
                        MenorDimensaoEdificio: resposta.MenorDimensaoEdificio,
                        Vidros: resposta.Vidros,
                        AlturaVidro: resposta.AlturaVidro,
                        LarguraVidro: resposta.LarguraVidro,
                        AnguloVidro: resposta.AnguloVidro,
                        ApoioVidro: resposta.ApoioVidro
                    };

                    LoadingService.loader.esconder();
                    vm.irPassoPosterior();

                    /// setTimeout(function () {
                    //         window.print();
                    //     },
                    //     1000);
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        };

        vm.pegarPrimeiroNomeVidro = function(nomeVidro){
            return nomeVidro.split(' ')[0];
        };

        vm.montarExibicaoVidroAceito = function(vidro){
          if (vidro.Espessura){
              var exibicao = vm.montarNomeVidroMonolitico(vidro);

              return { Descricao: exibicao.Descricao, Espessura: exibicao.Espessura};
          }
            else {
              if (!vidro.Composicao){
                  return { Descricao: '', Espessura: 0};
              }

              var espessuraTotal = 0;
              var vidrosInternos = '';

              angular.forEach(vidro.Composicao, function (objeto, indice) {
                  var exibicao = vm.montarExibicaoVidroAceito(objeto);

                  vidrosInternos += (vidrosInternos != '' ? ' + ' + exibicao.Descricao : exibicao.Descricao);
                  espessuraTotal += exibicao.Espessura;
              });

              return { Descricao: vidro.NomeVidro.split(' ')[0] + ' ' + espessuraTotal + 'mm (' + vidrosInternos + ')', Espessura: espessuraTotal};
          }
        };

        vm.montarNomeVidroMonolitico = function(vidro){
            return { Descricao: vidro.NomeVidro + ' ' + vidro.Espessura + 'mm', Espessura: vidro.Espessura };
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.primeiro.passo',
            [
                //'terreno.regiao.eolica',
                //'terreno.rugosidade',
                //'terreno.topografia'
                'pressao.vento.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/pressao-vento/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'PressaoVentoPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
  'use strict';

  angular
      .module('pressao.vento.primeiro.passo.controller', ['local.factory'])
      .controller('PressaoVentoPrimeiroPassoController', PressaoVentoPrimeiroPassoController);

  /** @ngInject */
  function PressaoVentoPrimeiroPassoController($scope, $state, $q, BarraProgressoService, RouteDefinitionService, CalculoEspessuraService, toastr, LocalFactory, LoadingService) {

    var vm = this;
    vm.PressaoVentoModel = CalculoEspessuraService.PressaoVentoModel;
    vm.sourceRegioes = [];
    vm.sourceRugosidade = [];
    vm.sourceTopografia = [];

    BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
    BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

    vm.selecionadoRegiao = function () {
      var selecionada = angular.element.grep(vm.sourceRegioes, function (regiao) {
        return regiao.selecionada;
      })[0];
      return selecionada;
    };

    vm.corRandom = function () {
      var letters = '0123456789ABCDEF'.split('');
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };

    if (CalculoEspessuraService.PressaoVentoModel.Terreno.RegiaoEolica) {
      angular.element(vm.sourceRegioes).each(function (iR, regiao) {
        regiao.selecionada = regiao.Descricao == CalculoEspessuraService.PressaoVentoModel.Terreno.RegiaoEolica;
      });
    }

    vm.selecionarRegiao = function (paramRegiao) {
      var selecionada = angular.element.grep(vm.sourceRegioes, function (regiao) {
        return regiao.selecionada;
      })[0];
      if (selecionada) {
        selecionada.selecionada = false;
      }
      selecionada = angular.element.grep(vm.sourceRegioes, function (regiao) {
        return regiao.Cor == (paramRegiao.Cor ? paramRegiao.Cor : paramRegiao.color);
      })[0];
      if (selecionada) {
        selecionada.selecionada = true;
      }

    };

    vm.irPassoPosterior = function () {
      if (!vm.validarDados()) {
        return;
      }

      if (!vm.PressaoVentoModel.PressaoVentoManual) {
        if (vm.selecionadoRegiao()){
          vm.PressaoVentoModel.Terreno.RegiaoEolica = vm.selecionadoRegiao();
        }
        CalculoEspessuraService.PressaoVentoModel = vm.PressaoVentoModel;

        $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        return;
      }else{
        $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        return;
      }
    };

    vm.irPassoAnterior = function () {
      $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
    };

    vm.validarDados = function (){
      if (!vm.PressaoVentoModel.PressaoVentoManual){
          if (vm.PressaoVentoModel.AplicacaoVidroExterno){
            if(!vm.selecionadoRegiao()){
              toastr.warning("Selecione a região!");
              return false;
            }
            else if(!vm.PressaoVentoModel.Terreno.Topografia){
              toastr.warning("Selecione a topografia do terreno!");
              return false;
            }
            else if(!vm.PressaoVentoModel.Terreno.Rugosidade){
              toastr.warning("Selecione a rugosidade do terreno!");
              return false;
            }
            else {
              return true;
            }
          }
          else {
            return true;
          }
      }else{
        if ((vm.PressaoVentoModel.PressaoVento===undefined)||(vm.PressaoVentoModel.PressaoVento===0)||(vm.PressaoVentoModel.PressaoVento===null)){
          toastr.warning("Digite a Pressão do Vento");
          return false;
        }else{
          return true;
        }
      }

    };

    function init() {
      LoadingService.loader.exibir();

      var deferredRegioes = LocalFactory.buscarRegioes();
      var deferredTerrenos = LocalFactory.buscarTerrenos();
      var deferredRugosidades = LocalFactory.buscarRugosidades();

      $q.all([deferredRegioes, deferredTerrenos, deferredRugosidades])
          .then(function (resultados) {
            deferredRegioes.then(function (resultado) {
              vm.sourceRegioes = resultado;
            });

            deferredTerrenos.then(function (resultado) {
              vm.sourceTopografia = resultado;
            });

            deferredRugosidades.then(function (resultado) {
              vm.sourceRugosidade = resultado;
            });

            LoadingService.loader.esconder();
          })
          .catch(function (erros){
            LoadingService.loader.esconder();
          });
    };
    init();

  }
})();

(function () {
    'use strict';

    angular
        .module('prateleira.terceiro.passo',
            [
                'prateleira.terceiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira.terceiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('prateleira.terceiro-passo', {
                url: '/terceiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/prateleira/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html',
                        controller: 'PrateleiraTerceiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('prateleira.terceiro.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('PrateleiraTerceiroPassoController', PrateleiraTerceiroPassoController);

    /** @ngInject */
    function PrateleiraTerceiroPassoController($state, toastr, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, LoadingService, VidroFactory, CalculoFactory) {

        var vm = this;
        vm.model = CalculoEspessuraService.Prateleira;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.calcular = function () {
            if (!vm.validarDados()) {
                return;
            }

            LoadingService.loader.exibir();

            CalculoFactory.calcularPrateleira(vm.model)
                .then(function (resposta) {
                    vm.retorno = resposta;

                    vm.model.RelatorioFinal = resposta;

                    LoadingService.loader.esconder();
                    vm.irPassoPosterior();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        };

        vm.validarDados = function () {
           if (!vm.model.nome) {
                toastr.warning('Nome não informado!', 'Nome do Solicitante');
                return false;
            }
            else if (!vm.model.telefone) {
                toastr.warning('Telefone não informado!', 'Telefone do Solicitante');
                return false;
            }
            else if (!vm.model.empresa) {
                toastr.warning('Empresa não informada!', 'Empresa do Solicitante');
                return false;
            }
            else if (!vm.model.obra) {
                toastr.warning('Obra não informada!', 'Obra do Solicitante');
                return false;
            }
            else if (!vm.model.email) {
                toastr.warning('Email não informado!', 'Email do Solicitante');
                return false;
            }
            else {
                return true;
            }
        };

        function init() {

            LoadingService.loader.exibir();

            VidroFactory.buscarTiposVidrosTampo()
                .then(function (resultado) {
                    vm.sourceTiposVidro = resultado;

                    LoadingService.loader.esconder();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        }
        init();
    }
})();

(function () {
    'use strict';

    angular
        .module('prateleira.segundo.passo',
            [
                'prateleira.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('prateleira.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/prateleira/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'PrateleiraSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
  'use strict';

  angular
    .module('prateleira.segundo.passo.controller', ['calculo.factory'])
    .controller('PrateleiraSegundoPassoController', PrateleiraSegundoPassoController);

  /** @ngInject */
  function PrateleiraSegundoPassoController($state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, CalculoFactory, VidroFactory) {

    var vm = this;
    vm.model = CalculoEspessuraService.Prateleira;
    vm.sourceTiposVidro = [];
    vm.sourceEspessuras = [];
    vm.sourceDistanciaEntreApoios = [];
    BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
    BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
    SelecaoObjetivoService.podeAlterar = false;

    vm.irPassoPosterior = function () {
      if (!vm.validarDados()) {
        return;
      }

      $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
    };

    vm.irPassoAnterior = function () {
      $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
    };

    vm.obterEspessuras = function (iniciarComponent) {

      if (!iniciarComponent) {
        vm.model.espessuraId = null;
        vm.model.distanciaApoioId = null;
        vm.model.larguraPeca = null;
        vm.model.cargaMaxima = null;
      }

      if (vm.model.tipoCalculoId !== 2) {
        vm.obterDistancia();
        return;
      }

      LoadingService.loader.exibir();

      if (vm.model.tipoVidroId === null) {
        toastr.warning('Tipo vidro não informado!', 'Tipo vidro');
        return;
      }

      VidroFactory.buscarTiposEspessurasPrateleira(vm.model.isCemPorCentoApoiada, vm.model.tipoVidroId)
        .then(function (resposta) {
          vm.sourceEspessuras = resposta;
          LoadingService.loader.esconder();
        })
        .catch(function (erro) {
          LoadingService.loader.esconder();
        });
    };

    vm.obterDistancia = function () {

      LoadingService.loader.exibir();

      VidroFactory.buscarDistanciaPrateleira(vm.model.tipoVidroId, vm.model.espessuraId)
        .then(function (resposta) {
          vm.sourceDistanciaEntreApoios = resposta;
          LoadingService.loader.esconder();
        })
        .catch(function (erro) {
          LoadingService.loader.esconder();
        });
    };

    vm.validarDados = function () {
      if (!vm.model.tipoVidroId) {
        toastr.warning('Tipo vidro não informado!', 'Tipo vidro');
        return false;
      }
      else if (!vm.model.espessuraId && vm.model.tipoCalculoId === 2) {
        toastr.warning('Espessura da peça não informada!', 'Espessura da peça');
        return false;
      }
      else if (!vm.model.distanciaApoioId) {
        toastr.warning('Distância entre apoios não informado!', 'Distância entre apoios');
        return false;
      }
      else if (!vm.model.larguraPeca) {
        toastr.warning('Largura da peça não informada!', 'Largura da peça');
        return false;
      }
      else if (!vm.model.cargaMaxima && vm.model.tipoCalculoId === 1) {
        toastr.warning('Carga máxima não informada!', 'Carga máxima');
        return false;
      }
      else if (!vm.model.areaPeca) {
        toastr.warning('Área da peça não informada!', 'Área da peça');
        return false;
      }
      else {
        return true;
      }
    };

    function init() {

      LoadingService.loader.exibir();

      VidroFactory.buscarTiposVidrosPrateleira(vm.model.isCemPorCentoApoiada, vm.model.hasFuracao)
        .then(function (resultado) {
          vm.sourceTiposVidro = resultado;
          if (vm.model.tipoVidroId) vm.obterEspessuras(true);
          if (vm.model.espessuraId) vm.obterDistancia();

          LoadingService.loader.esconder();
        })
        .catch(function () {
          LoadingService.loader.esconder();
        });
    }
    init();
  }
})();

(function () {
    'use strict';

    angular
        .module('prateleira.quarto.passo',
            [
                'prateleira.quarto.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira.quarto.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('prateleira.quarto-passo', {
                url: '/quarto-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/prateleira/passo-a-passo/quarto-passo/quarto-passo.tpl.html',
                        controller: 'PrateleiraQuartoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('prateleira.quarto.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('PrateleiraQuartoPassoController', PrateleiraQuartoPassoController);

    /** @ngInject */
    function PrateleiraQuartoPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.Prateleira.RelatorioFinal;
        vm.calculoId = vm.model.TipoCalculoId;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.imprimir = function () {
            window.print();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('prateleira.primeiro.passo',
            [
                'prateleira.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('prateleira.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/prateleira/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'PrateleiraPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
  'use strict';

  angular
    .module('prateleira.primeiro.passo.controller', ['calculo.factory'])
    .controller('PrateleiraPrimeiroPassoController', PrateleiraPrimeiroPassoController);

  /** @ngInject */
  function PrateleiraPrimeiroPassoController($state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, CalculoFactory, VidroFactory, LoadingService) {

    var vm = this;
    vm.model = CalculoEspessuraService.Prateleira;

    BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
    BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

    SelecaoObjetivoService.podeAlterar = true;

    vm.sourceTiposVidro = [];
    vm.tiposCalculo = [];
    vm.formasPrateleira = ['Retangular', 'Não Retangular'];

    vm.irPassoPosterior = function () {
      if (!vm.validarDados()) {
        return;
      }

      $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
    };

    vm.irPassoAnterior = function () {
      $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
    };

    vm.validarDados = function () {
      if (!vm.model.tipoCalculoId) {
        toastr.warning('Selecione a opção de tipo de cálculo!', 'Tipo cálculo não respondido!');
        return false;
      }
      if (vm.model.isCemPorCentoApoiada === null) {
        toastr.warning('Selecione a opção de prateleira apoiada ou não!', 'Questão 2 não respondida!');
        return false;
      }
      if (vm.model.hasFuracao === null) {
        toastr.warning('Selecione a opção se há furação ou não!', 'Questão 3 não respondida!');
        return false;
      }
      return true;
    };

    function init() {
      LoadingService.loader.exibir();

      CalculoFactory.buscarTipoCalculoPrateleira()
        .then(function (resultado) {
          vm.tiposCalculo = resultado;

          LoadingService.loader.esconder();
        })
        .catch(function (erro) {
          LoadingService.loader.esconder();
        });
    }
    init();

    vm.eRetangular = function (formaPrateleira) {
      return formaPrateleira === 'Retangular'
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.segundo.passo',
            [
                //'dados.apoio',
                //'dados.edificacao',
                //'dados.vidro'
                'piso.vidro.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('piso-vidro.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/piso-vidro/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'PisoVidroSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.segundo.passo.controller', [])
        .controller('PisoVidroSegundoPassoController', PisoVidroSegundoPassoController);

    /** @ngInject */
    function PisoVidroSegundoPassoController($scope, $state, $http, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr) {

        var vm = this;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.primeiro.passo',
            [
                'piso.vidro.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('piso-vidro.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/piso-vidro/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'PisoVidroPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.primeiro.passo.controller', [])
        .controller('PisoVidroPrimeiroPassoController', PisoVidroPrimeiroPassoController);

    /** @ngInject */
    function PisoVidroPrimeiroPassoController($scope, $state, $http, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr) {

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
        var vm = this;
        vm.model = CalculoEspessuraService.PisoVidroModel;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('espelho.terceiro.passo',
            [
                'espelho.terceiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('espelho.terceiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('espelho.terceiro-passo', {
                url: '/terceiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/espelho/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html',
                        controller: 'EspelhoTerceiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('espelho.terceiro.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('EspelhoTerceiroPassoController', EspelhoTerceiroPassoController);

    /** @ngInject */
    function EspelhoTerceiroPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.Espelho;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.imprimir = function () {
            window.print();
        };

        function init() {
        }
        //init();
    }
})();

(function () {
    'use strict';

    angular
        .module('espelho.segundo.passo',
            [
                'espelho.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('espelho.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('espelho.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/espelho/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'EspelhoSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('espelho.segundo.passo.controller', ['calculo.factory'])
        .controller('EspelhoSegundoPassoController', EspelhoSegundoPassoController);

    /** @ngInject */
    function EspelhoSegundoPassoController($scope, $state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, CalculoFactory) {

        var vm = this;
        vm.model = CalculoEspessuraService.Espelho;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
        SelecaoObjetivoService.podeAlterar = false;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.calcular = function () {
            if (!vm.validarDados()){
                return;
            }

            LoadingService.loader.exibir();

            CalculoFactory.calcularEspessuraEspelho(vm.model)
                .then(function (resposta) {
                    vm.retorno = resposta;

                    vm.model.RelatorioFinal = resposta;

                    LoadingService.loader.esconder();
                    vm.irPassoPosterior();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        };

        vm.validarDados = function (){
            if (!vm.model.Nome) {
                toastr.warning('Nome não informado!', 'Nome do Solicitante');
                return false;
            }
            else if(!vm.model.Telefone){
                toastr.warning('Telefone não informado!', 'Telefone do Solicitante');
                return false;
            }
            else if(!vm.model.Empresa){
                toastr.warning('Empresa não informada!', 'Empresa do Solicitante');
                return false;
            }
            else if(!vm.model.Obra){
                toastr.warning('Obra não informada!', 'Obra do Solicitante');
                return false;
            }
            else if(!vm.model.Email){
                toastr.warning('Email não informado!', 'Email do Solicitante');
                return false;
            }
            else {
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('espelho.primeiro.passo',
            [
                'espelho.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('espelho.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('espelho.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/espelho/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'EspelhoPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('espelho.primeiro.passo.controller', ['calculo.factory'])
        .controller('EspelhoPrimeiroPassoController', EspelhoPrimeiroPassoController);

    /** @ngInject */
    function EspelhoPrimeiroPassoController($scope, $state, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, CalculoFactory, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.Espelho;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        SelecaoObjetivoService.podeAlterar = true;

        vm.irPassoPosterior = function () {
            if (!vm.validarDados()){
                return;
            }

            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if ((!vm.model.altura || vm.model.altura < 0.01) || (!vm.model.largura || vm.model.largura < 0.01)){
                toastr.warning("Informe a Altura e a Largura do espelho!");
                return false;
            }
            else {
                return true;
            }
        };

        function init() {
            LoadingService.loader.exibir();

            CalculoFactory.buscarTiposCalculoPiscinaAquario()
                .then(function (resultado) {
                    vm.sourceVisores = resultado;

                    if(vm.model.TipoVisor){
                        vm.selecionarVisor(vm.model.TipoVisor);
                    }

                    LoadingService.loader.esconder();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        }
        init();

    }
})();

(function () {
    'use strict';

    angular
        .module('box.terceiro.passo',
            [
                'box.terceiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box.terceiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('box.terceiro-passo', {
                url: '/terceiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/box/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html',
                        controller: 'BoxTerceiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('box.terceiro.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('BoxTerceiroPassoController', BoxTerceiroPassoController);

    /** @ngInject */
    function BoxTerceiroPassoController($scope, $state, $q, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, CalculoFactory) {

        var vm = this;
        vm.model = CalculoEspessuraService.Box;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);
        SelecaoObjetivoService.podeAlterar = false;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.calcular = function () {
            if (!vm.validarDados()){
                return;
            }

            LoadingService.loader.exibir();

            CalculoFactory.calcularEspessuraBox(vm.model)
                .then(function (resposta) {
                    vm.retorno = resposta;

                    vm.model.RelatorioFinal = resposta;

                    LoadingService.loader.esconder();
                    vm.irPassoPosterior();
                })
                .catch(function (erro) {
                    LoadingService.loader.esconder();
                });
        };

        vm.validarDados = function (){
            if (!vm.model.Nome) {
                toastr.warning('Nome não informado!', 'Nome do Solicitante');
                return false;
            }
            else if(!vm.model.Telefone){
                toastr.warning('Telefone não informado!', 'Telefone do Solicitante');
                return false;
            }
            else if(!vm.model.Empresa){
                toastr.warning('Empresa não informada!', 'Empresa do Solicitante');
                return false;
            }
            else if(!vm.model.Obra){
                toastr.warning('Obra não informada!', 'Obra do Solicitante');
                return false;
            }
            else if(!vm.model.Email){
                toastr.warning('Email não informado!', 'Email do Solicitante');
                return false;
            }
            else {
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('box.quarto.passo',
            [
                'box.quarto.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box.quarto.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('box.quarto-passo', {
                url: '/quarto-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/box/passo-a-passo/quarto-passo/quarto-passo.tpl.html',
                        controller: 'BoxQuartoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('box.quarto.passo.controller', ['calculo.factory', 'cebraceCredito.filter'])
        .controller('BoxQuartoPassoController', BoxQuartoPassoController);

    /** @ngInject */
    function BoxQuartoPassoController($state, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, LoadingService) {

        var vm = this;
        vm.model = CalculoEspessuraService.Box;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.imprimir = function () {
            window.print();
        };

        function init() {
        }
        //init();
    }
})();

(function () {
    'use strict';

    angular
        .module('box.segundo.passo',
            [
                'box.segundo.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box.segundo.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('box.segundo-passo', {
                url: '/segundo-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/box/passo-a-passo/segundo-passo/segundo-passo.tpl.html',
                        controller: 'BoxSegundoPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('box.segundo.passo.controller', ['calculo.factory'])
        .controller('BoxSegundoPassoController', BoxSegundoPassoController);

    /** @ngInject */
    function BoxSegundoPassoController($scope, $state, $q, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, VidroFactory, lodash) {

        var vm = this;
        vm.model = CalculoEspessuraService.Box;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        SelecaoObjetivoService.podeAlterar = true;

        vm.sourceTiposPeca = [];
        vm.sourceTiposVidro = [];

        vm.modeloPeca = {};

        vm.validarPeca = function () {
            return vm.modeloPeca.tipoPeca &&
                (vm.modeloPeca.altura && vm.modeloPeca.altura > 0) &&
                (vm.modeloPeca.largura && vm.modeloPeca.largura > 0);
        };

        vm.adicionarPeca = function () {
            if (vm.modeloPeca.altura > 2 || vm.modeloPeca.largura > 1){
                toastr.warning("As dimensões máximas previstas na NBR 14207 são 2 metros de altura por 1 metro de comprimento. Valores acima dessas medidas devem ser recomendados por um responsável técnico habilitado.");
                return;
            }

            var peca = lodash.clone(vm.modeloPeca);

            peca.tipoVidro = vm.model.TipoVidro;
            peca.tipoAplicacao = vm.model.TipoAplicacao;
            peca.Altura = peca.altura;
            peca.Largura = peca.largura;
            peca.TipoPecaId = peca.tipoPeca.Id;
            peca.TipoVidroAplicacaoId = peca.tipoAplicacao.Id;

            if (!vm.model.Pecas)
                vm.model.Pecas = [];

            vm.model.Pecas.push(peca);
            vm.modeloPeca.altura = null;
            vm.modeloPeca.largura = null;
        };

        vm.removerPeca = function (pecaRemovida) {
            lodash.remove(vm.model.Pecas, function (peca) {
                return peca == pecaRemovida;
            });
        };

        vm.irPassoPosterior = function () {
            if (!vm.validarDados()){
                return;
            }

            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if(!vm.model.Pecas && vm.model.Pecas.length == 0){
                toastr.warning("Adicione pelo menos uma peça para cálculo!");
                return false;
            }
            else {
                return true;
            }
        };

        function init() {
            LoadingService.loader.exibir();

            var promessaTipoPeca = VidroFactory.buscarTiposPecasBox();

            $q.all([promessaTipoPeca])
                .then(function (resultados) {
                    promessaTipoPeca
                        .then(function (resultado) {
                            vm.sourceTiposPeca = resultado;
                        });

                    LoadingService.loader.esconder();
                })
                .catch(function (erros) {
                    LoadingService.loader.esconder();
                });
        }
        init();
    }
})();

(function () {
    'use strict';

    angular
        .module('box.primeiro.passo',
            [
                'box.primeiro.passo.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box.primeiro.passo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('box.primeiro-passo', {
                url: '/primeiro-passo',
                views: {
                    '@': {
                        templateUrl: 'app/view/box/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html',
                        controller: 'BoxPrimeiroPassoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('box.primeiro.passo.controller', ['calculo.factory'])
        .controller('BoxPrimeiroPassoController', BoxPrimeiroPassoController);

    /** @ngInject */
    function BoxPrimeiroPassoController($scope, $state, $q, SelecaoObjetivoService, RouteDefinitionService, CalculoEspessuraService, BarraProgressoService, toastr, LoadingService, VidroFactory, lodash) {

        var vm = this;
        vm.model = CalculoEspessuraService.Box;

        BarraProgressoService.DefinirPassos(RouteDefinitionService.ObterState($state.current.name).module);
        BarraProgressoService.IrPasso(RouteDefinitionService.ObterState($state.current.name).titulo);

        SelecaoObjetivoService.podeAlterar = true;

        vm.sourceTiposPeca = [];
        vm.sourceTiposVidro = [];
        
        vm.irPassoPosterior = function () {
            if (!vm.validarDados()){
                return;
            }

            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        vm.irPassoAnterior = function () {
            $state.go(RouteDefinitionService.ObterStateAnterior($state.current.name));
        };

        vm.validarDados = function (){
            if(!vm.model.TipoVidro){
                toastr.warning("Selecione o tipo do vidro!");
                return false;
            }
            else if(!vm.model.TipoAplicacao){
                toastr.warning("Selecione o tipo de aplicação!");
                return false;
            }
            else {
                return true;
            }
        };

        function init() {
            LoadingService.loader.exibir();

            var promessaTipoPeca = VidroFactory.buscarTiposPecasBox();
            var promessaTipoVidro = VidroFactory.buscarTiposVidrosBox();

            $q.all([promessaTipoPeca, promessaTipoVidro])
                .then(function (resultados) {
                    promessaTipoPeca
                        .then(function (resultado) {
                            vm.sourceTiposPeca = resultado;
                    });

                    promessaTipoVidro
                        .then(function (resultado) {
                            vm.sourceTiposVidro = resultado;
                        });

                    if (vm.model.Pecas && vm.model.Pecas.length > 0){
                        vm.modeloPeca.tipoVidro = vm.model.Pecas[0].tipoVidro;
                        vm.modeloPeca.tipoAplicacao = vm.model.Pecas[0].tipoAplicacao;
                    }

                    LoadingService.loader.esconder();
                })
                .catch(function (erros) {
                    LoadingService.loader.esconder();
                });
        }
        init();

    }
})();

(function () {
    'use strict';

    angular.module('selecao-objetivo.service', [])
        .service('SelecaoObjetivoService', SelecaoObjetivoService);

    /** @ngInject */
    function SelecaoObjetivoService() {

        var service = this;
        service.podeAlterar = true;


    }


})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.selecao.objetivo.controller', [])
        .controller('VisorPiscinaSelecaoObjetivoController', VisorPiscinaSelecaoObjetivoController);

    /** @ngInject */
    function VisorPiscinaSelecaoObjetivoController($scope, $state, $http, RouteDefinitionService, SelecaoObjetivoService, toastr) {

        var vm = this;

        vm.SelecaoObjetivoService = SelecaoObjetivoService;

        vm.sourceObjetivo = [
            {name:'Visor de Piscina'},
            {name:'Visor de Aquário'}
        ];

    }
})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.apresentacao',
            [
                'visor.piscina.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('visor-piscina.apresentacao', {
                url: '/apresentacao',
                views: {
                    '@': {
                        templateUrl: 'app/view/visor-piscina/apresentacao/apresentacao.tpl.html',
                        controller: 'VisorPiscinaApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.apresentacao.controller', [])
        .controller('VisorPiscinaApresentacaoController', VisorPiscinaApresentacaoController);

    /** @ngInject */
    function VisorPiscinaApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('tampo.apresentacao',
            [
                'tampo.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('tampo.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('tampo.apresentacao', {
                url: '/tampo',
                views: {
                    '@': {
                        templateUrl: 'app/view/tampo/apresentacao/apresentacao.tpl.html',
                        controller: 'TampoApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('tampo.apresentacao.controller', [])
        .controller('TampoApresentacaoController', TampoApresentacaoController);

    /** @ngInject */
    function TampoApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.apresentacao',
            [
                'pressao.vento.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento.apresentacao', {
                url: '/apresentacao',
                views: {
                    '@': {
                        templateUrl: 'app/view/pressao-vento/apresentacao/apresentacao.tpl.html',
                        controller: 'PressaoVentoApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.apresentacao.controller', [])
        .controller('PressaoVentoApresentacaoController', PressaoVentoApresentacaoController);

    /** @ngInject */
    function PressaoVentoApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;
        
        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('prateleira.apresentacao',
            [
                'prateleira.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('prateleira.apresentacao', {
                url: '/prateleira',
                views: {
                    '@': {
                        templateUrl: 'app/view/prateleira/apresentacao/apresentacao.tpl.html',
                        controller: 'PrateleiraApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('prateleira.apresentacao.controller', [])
        .controller('PrateleiraApresentacaoController', PrateleiraApresentacaoController);

    /** @ngInject */
    function PrateleiraApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.apresentacao',
            [
                'piso.vidro.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('piso-vidro.apresentacao', {
                url: '/apresentacao',
                views: {
                    '@': {
                        templateUrl: 'app/view/piso-vidro/apresentacao/apresentacao.tpl.html',
                        controller: 'PisoVidroApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.apresentacao.controller', [])
        .controller('PisoVidroApresentacaoController', PisoVidroApresentacaoController);

    /** @ngInject */
    function PisoVidroApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('espelho.apresentacao',
            [
                'espelho.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('espelho.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('espelho.apresentacao', {
                url: '/apresentacao',
                views: {
                    '@': {
                        templateUrl: 'app/view/espelho/apresentacao/apresentacao.tpl.html',
                        controller: 'EspelhoApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('espelho.apresentacao.controller', [])
        .controller('EspelhoApresentacaoController', EspelhoApresentacaoController);

    /** @ngInject */
    function EspelhoApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('configuracao.regra',
            [
                'configuracao.regra.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('configuracao.regra')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('configuracao.regra', {
                url: '/regra',
                views: {
                    '@': {
                        templateUrl: 'app/view/configuracao/regra/regra.tpl.html',
                        controller: 'RegraController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('configuracao.regra.controller', ['cebraceCredito.filter', 'regra.factory'])
        .controller('RegraController', RegraController);

    /** @ngInject */
    function RegraController($state, RouteDefinitionService, LoadingService, RegraFactory) {

        var vm = this;

        vm.sourceRegras = [];
        vm.regraEdicao = {};

        vm.mostrarModalEditarRegra = function () {
            angular.element('#ModalEditarRegra').modal('show');
        };

        vm.editarRegra = function (regra) {
            vm.regraEdicao = angular.copy(regra);

            vm.mostrarModalEditarRegra();
        };

        vm.confirmarEdicao = function(regra){
            LoadingService.loader.exibir();

            RegraFactory.atualizarRegra(regra)
                .then(function (resultado) {
                    angular.element('#ModalEditarRegra').modal('hide');
                    LoadingService.loader.esconder();
                    init();
                })
                .catch(function (erro) {
                    console.log(erro);
                    LoadingService.loader.esconder();
                });
        };

        function init() {
            LoadingService.loader.exibir();

            RegraFactory.buscarRegras()
                .then(function (resultado) {
                    vm.sourceRegras = resultado;
                    LoadingService.loader.esconder();
                })
                .catch(function (erro) {
                    console.log(erro);
                    LoadingService.loader.esconder();
                });
        }
        init();
    }
})();

(function () {
    'use strict';

    angular
        .module('box.apresentacao',
            [
                'box.apresentacao.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box.apresentacao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('box.apresentacao', {
                url: '/apresentacao',
                views: {
                    '@': {
                        templateUrl: 'app/view/box/apresentacao/apresentacao.tpl.html',
                        controller: 'BoxApresentacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('box.apresentacao.controller', [])
        .controller('BoxApresentacaoController', BoxApresentacaoController);

    /** @ngInject */
    function BoxApresentacaoController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });

    }
})();

(function () {
  'use strict';

  angular.module('vidro-dctv.directive', [])
    .directive('vidroDctv', vidroDctv);

  /** @ngInject */
  function vidroDctv(lodash) {

    return {
      restrict: 'E',
      replace: true,
      scope: {
        composicoes: '=',
        aoSelecionarVidroCallback: '=',
        composicaoMae: '='
      },
      controllerAs: 'controller',
      templateUrl: 'app/common/directive/vidro-dctv/vidro-dctv.tpl.html',
      link: function (scope, element, attrs) {

        scope.selecionados = {}

        if (scope.composicoes.length == 1) {
          scope.selecionados.composto = scope.composicoes[0];
        }

        scope.aoSelecionarVidro = function (vidro) {
          vidro.Composicoes = [];
          for (var x = 1; x <= vidro.QuantidadeVidros; x++) {
            vidro.Composicoes.push({id: x, vidro: undefined});
          }
          atribuirVidroAcomposicaoMae(vidro);
          dispararCallbackAoSelecionarVidro(vidro);
        };

        scope.alternarCollapse = function () {
          scope.collapse = !scope.collapse;
        };

        scope.existeInsulado = function () {
          return lodash.filter(scope.composicoes, function (composicao) {
              return composicao.Id == 1;
            }).length > 0;
        };

        scope.existeLaminado = function () {
          return lodash.filter(scope.composicoes, function (composicao) {
              return composicao.Id == 2;
            }).length > 0;
        };

        function atribuirVidroAcomposicaoMae(vidro) {
          if (scope.composicaoMae) {
            scope.composicaoMae.vidro = vidro;
          }
        };

        function dispararCallbackAoSelecionarVidro(vidro) {
          if (scope.aoSelecionarVidroCallback) {
            scope.aoSelecionarVidroCallback(vidro);
          }
        };
      }
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina',
            [
                'visor.piscina.apresentacao',
                'visor.piscina.passo.a.passo',
                'visor.piscina.selecao.objetivo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('visor-piscina', {
                url: '/visor-piscina',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                    /*
                    'selecaoObjetivo': {
                        templateUrl: 'app/view/visor-piscina/selecao-objetivo/selecao-objetivo.tpl.html',
                        controller: 'VisorPiscinaSelecaoObjetivoController',
                        controllerAs: 'vm'
                    },
                    'selecaoVidro': {
                        templateUrl: 'app/view/selecao-vidro/selecao-vidro.tpl.html',
                        controller: 'SelecaoVidroController',
                        controllerAs: 'vm'
                    }
                    */
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('tampo',
            [
                'tampo.apresentacao',
                'tampo.passo.a.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('tampo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('tampo', {
                url: '/tampo',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('selecao.vidro.service', [])
        .service('SelecaoVidroService', SelecaoVidroService);

    /** @ngInject */
    function SelecaoVidroService() {

        var service = this;
        service.podeAlterar = true;


    }


})();

(function () {
    'use strict';

    angular
        .module('selecao.vidro.controller', [])
        .controller('SelecaoVidroController', SelecaoVidroController);

    /** @ngInject */
    function SelecaoVidroController($scope, $state, $http, RouteDefinitionService, toastr) {

        var vm = this;

        vm.sourceVidro = [
            {name:'Vidro Interno'},
            {name:'Vidro Externo'}
        ];

    }
})();

(function () {
    'use strict';

    angular
        .module('pressao.vento',
            [
                'pressao.vento.apresentacao',
                'pressao.vento.passo.a.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('pressao-vento', {
                url: '/pressao-vento',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                    /*'selecaoVidro': {
                     templateUrl: 'app/view/selecao-vidro/selecao-vidro.tpl.html',
                     controller: 'SelecaoVidroController',
                     controllerAs: 'vm'
                     }*/
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('prateleira',
            [
                'prateleira.apresentacao',
                'prateleira.passo.a.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('prateleira', {
                url: '/prateleira',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro',
            [
                'piso.vidro.apresentacao',
                'piso.vidro.passo.a.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('piso-vidro', {
                url: '/piso-vidro',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                    /*'selecaoVidro': {
                        templateUrl: 'app/view/selecao-vidro/selecao-vidro.tpl.html',
                        controller: 'SelecaoVidroController',
                        controllerAs: 'vm'
                    }*/
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('main.controller', [])
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($timeout, $state, RouteDefinitionService) {

        var vm = this;

        /*$state.go('pressao-vento');

        vm.irPassoPosterior = function () {
            $state.go(RouteDefinitionService.ObterStatePosterior($state.current.name));
        };

        var _counter = -500;
        angular.element('.row div.opacity0').each(function (iE, element) {
            $timeout(function () {
                angular.element(element).animate({opacity: 1}, 1000);
            }, _counter += 500);
        });*/


    }
})();

(function () {
    'use strict';

    angular
        .module('espelho',
            [
                'espelho.apresentacao',
                'espelho.passo.a.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('espelho')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('espelho', {
                url: '/espelho',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('configuracao',
            [
                'configuracao.regra'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('configuracao')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('configuracao', {
                url: '/configuracao',
                abstract: true,
                views: {
                    /*'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                    'selecaoObjetivo': {
                        templateUrl: 'app/view/visor-piscina/selecao-objetivo/selecao-objetivo.tpl.html',
                        controller: 'VisorPiscinaSelecaoObjetivoController',
                        controllerAs: 'vm'
                    },
                    'selecaoVidro': {
                        templateUrl: 'app/view/selecao-vidro/selecao-vidro.tpl.html',
                        controller: 'SelecaoVidroController',
                        controllerAs: 'vm'
                    }*/
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('box',
            [
                'box.apresentacao',
                'box.passo.a.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('box', {
                url: '/box',
                abstract: true,
                views: {
                    'barraProgresso': {
                        templateUrl: 'app/view/barra-progresso/barra-progresso.tpl.html',
                        controller: 'BarraProgressoController',
                        controllerAs: 'vm'
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('barra.progresso.service', [])
        .service('BarraProgressoService', BarraProgressoService);

    /** @ngInject */
    function BarraProgressoService(RouteDefinitionService, WizardHandler) {

        var service = this;

        service.passos = [];

        service.DefinirPassos = function (modulo) {
            if (service.passos.modulo != modulo) {
                service.passos = angular.element.grep(RouteDefinitionService.ObterStates(), function (state) {
                    return state.module == modulo;
                });
                service.passos.modulo = modulo
            }
        };

        service.IrPasso = function (titulo) {

            var selecionado = angular.element.grep(service.passos, function (state) {
                return state.selecionado;
            })[0];
            if (selecionado) {
                selecionado.selecionado = false;
            }

            selecionado = angular.element.grep(service.passos, function (state) {
                return state.titulo == titulo;
            })[0];
            if (selecionado) {
                selecionado.selecionado = true;
            }

        };


    }


})();

(function () {
    'use strict';

    angular
        .module('barra.progresso.controller', [])
        .controller('BarraProgressoController', BarraProgressoController);

    /** @ngInject */
    function BarraProgressoController($scope, $state, $http, BarraProgressoService, toastr) {

        var vm = this;

        vm.BarraProgressoService = BarraProgressoService;

    }
})();

(function () {
    'use strict';

    angular.module('route-definition.service', [])
        .service('RouteDefinitionService', RouteDefinitionService);

    /** @ngInject */
    function RouteDefinitionService() {

        var service = this;

        var sourceRoutes = [
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'pressao-vento.primeiro-passo',
            },
            {
                state: 'pressao-vento.primeiro-passo',
                statePosterior: 'pressao-vento.segundo-passo',
                module:'pressao-vento',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'pressao-vento.segundo-passo',
                statePosterior: 'pressao-vento.terceiro-passo',
                module:'pressao-vento',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'pressao-vento.terceiro-passo',
                statePosterior: 'pressao-vento.quarto-passo',
                module:'pressao-vento',
                titulo:'Terceiro Passo',
                ordemPasso:2
            },
            {
                state: 'pressao-vento.quarto-passo',
                statePosterior: 'pressao-vento.quinto-passo',
                module:'pressao-vento',
                titulo:'Quarto Passo',
                ordemPasso:3
            },
            {
                state: 'pressao-vento.quinto-passo',
                statePosterior: 'app.home',
                module:'pressao-vento',
                titulo:'Relatório',
                ordemPasso:4
            },
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'visor-piscina.primeiro-passo',
            },
            {
                state: 'visor-piscina.primeiro-passo',
                statePosterior: 'visor-piscina.segundo-passo',
                module:'visor-piscina',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'visor-piscina.segundo-passo',
                statePosterior: 'visor-piscina.terceiro-passo',
                module:'visor-piscina',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'visor-piscina.terceiro-passo',
                statePosterior: 'app.home',
                module:'visor-piscina',
                titulo:'Relatório',
                ordemPasso:2
            },
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'piso-vidro.primeiro-passo',
            },
            {
                state: 'piso-vidro.primeiro-passo',
                statePosterior: 'piso-vidro.segundo-passo',
                module:'piso-vidro',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'piso-vidro.segundo-passo',
                statePosterior: 'app.home',
                module:'piso-vidro',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'box.primeiro-passo',
            },
            {
                state: 'box.primeiro-passo',
                statePosterior: 'box.segundo-passo',
                module:'box',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'box.segundo-passo',
                statePosterior: 'box.terceiro-passo',
                module:'box',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'box.terceiro-passo',
                statePosterior: 'box.quarto-passo',
                module:'box',
                titulo:'Terceiro Passo',
                ordemPasso:2
            },
            {
                state: 'box.quarto-passo',
                statePosterior: 'app.home',
                module:'box',
                titulo:'Relatório',
                ordemPasso:2
            },
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'espelho.primeiro-passo',
            },
            {
                state: 'espelho.primeiro-passo',
                statePosterior: 'espelho.segundo-passo',
                module:'espelho',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'espelho.segundo-passo',
                statePosterior: 'espelho.terceiro-passo',
                module:'espelho',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'espelho.terceiro-passo',
                statePosterior: 'app.home',
                module:'espelho',
                titulo:'Relatório',
                ordemPasso:2
            },
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'tampo.primeiro-passo',
            },
            {
                state: 'tampo.primeiro-passo',
                statePosterior: 'tampo.segundo-passo',
                module:'tampo',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'tampo.segundo-passo',
                statePosterior: 'tampo.terceiro-passo',
                module:'tampo',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'tampo.terceiro-passo',
                statePosterior: 'app.home',
                module:'tampo',
                titulo:'Relatório',
                ordemPasso:2
            },
            {
                state: 'app.home',
                module:'home',
                statePosterior: 'prateleira.primeiro-passo',
            },
            {
                state: 'prateleira.primeiro-passo',
                statePosterior: 'prateleira.segundo-passo',
                module:'prateleira',
                titulo:'Primeiro Passo',
                ordemPasso:0
            },
            {
                state: 'prateleira.segundo-passo',
                statePosterior: 'prateleira.terceiro-passo',
                module:'prateleira',
                titulo:'Segundo Passo',
                ordemPasso:1
            },
            {
                state: 'prateleira.terceiro-passo',
                statePosterior: 'prateleira.quarto-passo',
                module:'prateleira',
                titulo:'Terceiro passo',
                ordemPasso:2
            },
            {
                state: 'prateleira.quarto-passo',
                statePosterior: 'app.home',
                module:'prateleira',
                titulo:'Relatório',
                ordemPasso:3
            }
        ];

        service.ObterStates = function (paramState) {
            return angular.copy(sourceRoutes);
        };

        service.ObterStateAnterior = function (paramState) {
            var state = angular.element.grep(sourceRoutes, function (state) {
                return state.statePosterior == paramState;
            })[0];
            return state.state;
        };

        service.ObterStatePosterior = function (paramState) {
            var state = angular.element.grep(sourceRoutes, function (state) {
                return state.state == paramState;
            })[0];
            return state.statePosterior;
        };

        service.ObterState = function (paramState) {
            var state = angular.element.grep(sourceRoutes, function (state) {
                return state.state == paramState;
            })[0];
            return state;
        };

        service.paramsStateAnterior = '';


    }


})();

(function () {
    'use strict';

    angular.module('model.service', [])
        .service('ModelService', ModelService);

    /** @ngInject */
    function ModelService() {

        var models = {};
        models.CalculoEspessura = function () {
            this.PressaoVento = new models.PressaoVento();
            this.PisoVidro = new models.PisoVidro();
            this.VisorPiscina = new models.VisorPiscina();
            this.Box = new models.Box();
            this.Espelho = new models.Espelho();
            this.Tampo = new models.Tampo();
            this.Prateleira = new models.Prateleira();

            return this;
        };

        models.PressaoVento = function () {
            this.Terreno = {
                RegiaoEolica: null,
                Rugosidade: null,
                Topografia: null
            };

            this.DadosVidro = {
                Altura: null,
                Angulo: null,
                Apoio: null,
                BordaLivre: null,
                Largura: null,
                Vidro: null
            };

            this.Edificacao = {
                Altura: null,
                MaiorDimensao: null,
                MenorDimensao: null
            };

            this.Solicitante = {
                Nome: null,
                Telefone: null,
                Empresa: null,
                Fax: null,
                Obra: null,
                Email: null
            };

            this.RelatorioFinal = {
                Nome: null,
                Telefone: null,
                Empresa: null,
                Fax: null,
                Obra: null,
                Email: null,
                Regiao: null,
                PressaoCalculo: null,
                PressaoDinamica: null,
                PressaoVento: null,
                AlturaEdificio: null,
                MaiorDimensaoEdificio: null,
                MenorDimensaoEdificio: null,
                Vidros: null,
                AlturaVidro: null,
                LarguraVidro: null,
                AnguloVidro: null,
                ApoioVidro: null
            };

            this.AplicacaoVidroExterno = false;
            return this;
        };

        models.PisoVidro = function () {
            this.PisoMaiorDimensao = null;
            this.PisoMenorDimensao = null;
            this.Local = null;
            return this;
        };

        models.VisorPiscina = function () {
            this.TipoVisor = null;
            this.VidroAltura = null;
            this.VidroLargura = null;
            this.AguaAltura = null;
            this.Nome = null;
            this.Telefone = null;
            this.Empresa = null;
            this.Fax = null;
            this.Obra = null;
            this.Email = null;

            this.RelatorioFinal = {
                AlturaAgua: null,
                AlturaVidro: null,
                AreaVidro: null,
                Email: null,
                Empresa: null,
                EspessuraRecomendada: null,
                Fax: null,
                LarguraVidro: null,
                Nome: null,
                Obra: null,
                Observacao: null,
                PesoVidro: null,
                Telefone: null,
                TaxaTrabalhoAdmissivel: null,
                TextoApoio: null,
                CaminhoImagem: null
            };
            return this;
        };

        models.Box = function () {
            this.Pecas = null;
            this.Nome = null;
            this.Telefone = null;
            this.Empresa = null;
            this.Fax = null;
            this.Obra = null;
            this.Email = null;
            this.TipoVidro = null;
            this.TipoAplicacao = null;

            return this;
        };

        models.Espelho = function () {
            this.Altura = null;
            this.Largura = null;
            this.Nome = null;
            this.Telefone = null;
            this.Empresa = null;
            this.Fax = null;
            this.Obra = null;
            this.Email = null;

            return this;
        };

        models.Tampo = function () {
            this.Largura = null;
            this.Comprimento = null;
            this.Diametro = null;
            this.AlturaAplicacao = null;
            this.SuperficieTodaApoiada = false;
            this.TampoRedondo = false;
            this.TipoVidroId = null;
            this.Nome = null;
            this.Telefone = null;
            this.Empresa = null;
            this.Fax = null;
            this.Obra = null;
            this.Email = null;

            return this;
        };

        models.Prateleira = function () {
            this.tipoCalculoId = null;
            this.isCemPorCentoApoiada = null;
            this.nome = null;
            this.telefone = null;
            this.empresa = null;
            this.fax = null;
            this.obra = null;
            this.email = null;
            this.distanciaApoioId = null;
            this.cargaMaxima = null;
            this.larguraPeca = null;
            this.areaPeca = null;
            this.hasFuracao = null;
            this.tipoVidroId = null;
            this.espessura = null;

            this.RelatorioFinal = {
                Email: null,
                Empresa: null,
                Fax: null,
                Nome: null,
                Obra: null,
                Telefone: null,
                IsCemPorCentoApoiada: null,
                LarguraPeca: null,
                AreaPeca: null,
                TipoVidro: null,
                Espessura: null,
                DistanciaApoio: null,
                CargaMaxima: null,
                HasFuracao: null,
                TipoCalculoId: null
            };
            return this;
        };


        var service = this;
        service.CalculoEspessura = function () {
            return new models.CalculoEspessura();
        }


    }


})();

(function () {
    'use strict';

    angular.module('loading.service', [])
        .service('LoadingService', LoadingService);

    /** @ngInject */
    function LoadingService() {

        var _service = this;

        var _layoutLoader = {element: null, selector: '.loading-screen'};

        var _intervalInicializacao = setInterval(function () {
            if (_layoutLoader.element) {
                clearInterval(_intervalInicializacao);
            }
            else {
                if ($(_layoutLoader.selector).size() > 0) {
                    _layoutLoader.element = $(_layoutLoader.selector);
                }
            }
        }, 500);

        _service.loader = {
            esconder: function () {
                $(_layoutLoader.selector).fadeOut(300);
            },
            exibir: function () {
                $(_layoutLoader.selector).fadeIn(300);
            },
        };


        var tentarEsconderLoader = function () {
            if (_layoutLoader.element) {
                $(_layoutLoader.selector).fadeOut(300);
            }
            else {
                setTimeout(function () {
                    tentarEsconderLoader();
                }, 300);
            }
        };

        var tentarExibirLoader = function () {
            if (_layoutLoader.element) {
                $(_layoutLoader.selector).fadeIn(300);
            }
            else {
                setTimeout(function () {
                    tentarExibirLoader();
                }, 300);
            }
        };


    }


})();

(function () {
    'use strict';

    angular.module('calculo-espessura.service', [])
        .service('CalculoEspessuraService', CalculoEspessuraService);

    /** @ngInject */
    function CalculoEspessuraService(ModelService) {

        var service = this;
        var model = new ModelService.CalculoEspessura();
        service.PressaoVentoModel = model.PressaoVento;
        service.PisoVidroModel = model.PisoVidro;
        service.VisorPiscinaModel = model.VisorPiscina;
        service.Box = model.Box;
        service.Espelho = model.Espelho;
        service.Tampo = model.Tampo;
        service.Prateleira = model.Prateleira;

        service.resetarModel = function () {
            service.model = new ModelService.CalculoEspessura();
        }

    }


})();

(function () {
    'use strict';

    angular
        .module('unidade.filter', [])
        .filter('unidade', unidade);

    function unidade($filter) {
        return function (input, decimais, unidadeMedida) {
            if (!input){
                return '';
            }

            return $filter('number')(input, decimais) + unidadeMedida;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('numero-telefone.filter', [])
        .filter('numeroTelefone', numeroTelefone);

    function numeroTelefone($filter) {
        return function (numero) {
            if (!numero){
                return '';
            }

            var ddd = '';
            var prefixo = '';
            var sufixo = '';

            if (numero.length == 10){
                ddd = numero.slice(0,2);
                prefixo = numero.slice(2,6);
                sufixo = numero.slice(6,10);
            }
            else{
                ddd = numero.slice(0,2);
                prefixo = numero.slice(2,7);
                sufixo = numero.slice(7,11);
            }

            return '(' + ddd + ') ' + prefixo + '-' + sufixo;
        }
    }

})();

(function () {
  'use strict';

  angular.module('vidro.factory', [])
    .service('VidroFactory', VidroFactory);

  /** @ngInject */
  function VidroFactory($http, API) {

    var factory = function (data) {
      angular.extend(this, data);
    };

    factory.buscarTiposVidro = buscarTiposVidro;
    factory.buscarVidros = buscarVidros;
    factory.buscarComposicoesPossiveis = buscarComposicoesPossiveis;
    factory.buscarTiposPecasBox = buscarTiposPecasBox;
    factory.buscarTiposVidrosBox = buscarTiposVidrosBox;
    factory.buscarTiposVidrosTampo = buscarTiposVidrosTampo;
    factory.buscarTiposVidrosPrateleira = buscarTiposVidrosPrateleira;
    factory.buscarTiposEspessurasPrateleira = buscarTiposEspessurasPrateleira;
    factory.buscarDistanciaPrateleira = buscarDistanciaPrateleira;


    function buscarTiposVidro() {
      return $http.get(API.URL + 'Vidro/BuscarTiposVidro')
        .then(function (response) {
          return response;
        });
    }

    function buscarVidros(tipoVidroId) {
      return $http.get(API.URL + 'Vidro/BuscarVidrosPorTipo/' + tipoVidroId)
        .then(function (response) {
          return response;
        });
    }

    function buscarComposicoesPossiveis(tipoVidroId) {
      return $http.get(API.URL + 'Vidro/BuscarComposicoesPossiveis/' + tipoVidroId)
        .then(function (response) {
          return response;
        });
    }

    function buscarTiposPecasBox() {
      return $http.get(API.URL + 'Vidro/BuscarTiposPecasBox')
        .then(function (response) {
          return response;
        });
    }

    function buscarTiposVidrosBox() {
      return $http.get(API.URL + 'Vidro/BuscarTiposVidrosBox')
        .then(function (response) {
          return response;
        });
    }

    function buscarTiposVidrosTampo() {
      return $http.get(API.URL + 'Vidro/BuscarTiposVidrosTampo')
        .then(function (response) {
          return response;
        });
    }

    function buscarTiposVidrosPrateleira(isCemPorcentoApoiada, hasFuracao) {
      return $http.get(API.URL + 'Prateleiras/TiposVidros/' + isCemPorcentoApoiada + '/' + hasFuracao)
        .then(function (response) {
          return response;
        });
    }

    function buscarTiposEspessurasPrateleira(isCemPorcentoApoiada, tipoVidroId) {
      return $http.get(API.URL + 'Prateleiras/Espessuras/' + isCemPorcentoApoiada + '/TipoVidro/' + tipoVidroId)
        .then(function (response) {
          return response;
        });
    }

    function buscarDistanciaPrateleira(tipoVidroId, espessuraId) {
      return $http.get(API.URL + 'Prateleiras/DistanciasApoios/TipoVidro/' + tipoVidroId + '/Espessura/' + espessuraId)
        .then(function (response) {
          return response;
        });
    }

    return factory;
  }

})();

(function () {
    'use strict';

    angular.module('regra.factory', [])
        .service('RegraFactory', RegraFactory);

    /** @ngInject */
    function RegraFactory($http, API) {

        var factory = function (data) {
            angular.extend(this, data);
        };

        factory.buscarRegras = buscarRegras;
        factory.atualizarRegra = atualizarRegra;

        function buscarRegras() {
            return $http.get(API.URL + 'Regras/BuscarRegras')
                .then(function (response) {
                    return response;
                });
        }

        function atualizarRegra(entidade) {
            return $http.post(API.URL + 'Regras/AtualizarRegra', entidade)
                .then(function (response) {
                    return response;
                });
        }

        return factory;
    }

})();

(function () {
  'use strict';

  angular.module('local.factory', [])
    .service('LocalFactory', LocalFactory);

  /** @ngInject */
  function LocalFactory($http, API) {

    var factory = function (data) {
      angular.extend(this, data);
    };

    factory.buscarRegioes = buscarRegioes;
    factory.buscarTerrenos = buscarTerrenos;
    factory.buscarRugosidades = buscarRugosidades;


    function buscarRegioes() {

      return $http.get(API.URL + 'Local/BuscarRegioes')
        .then(function (response) {
          return response;
        });
    }

    function buscarTerrenos() {
      return $http.get(API.URL + 'Local/BuscarTerrenos')
        .then(function (response) {
          return response;
        });
    }

    function buscarRugosidades() {
      return $http.get(API.URL + 'Local/BuscarRugosidades')
        .then(function (response) {
          return response;
        });
    }

    return factory;
  }

})();

(function () {
  'use strict';

  angular.module('calculo.factory', [])
    .service('CalculoFactory', CalculoFactory);

  /** @ngInject */
  function CalculoFactory($http, API) {

    var factory = function (data) {
      angular.extend(this, data);
    };

    factory.calcularPressaoVento = calcularPressaoVento;
    factory.calcularPiscinaAquario = calcularPiscinaAquario;
    factory.buscarTiposCalculoPiscinaAquario = buscarTiposCalculoPiscinaAquario;
    factory.calcularEspessuraBox = calcularEspessuraBox;
    factory.calcularEspessuraEspelho = calcularEspessuraEspelho;
    factory.calcularEspessuraTampo = calcularEspessuraTampo;
    factory.calcularPrateleira = calcularPrateleira;
    factory.buscarTipoCalculoPrateleira = buscarTipoCalculoPrateleira;

    function calcularPressaoVento(entidade) {
      return $http.post(API.URL + 'Calculos/CalcularPressaoVento', entidade)
        .then(function (response) {
          return response;
        });
    }

    function calcularPiscinaAquario(entidade) {
      return $http.post(API.URL + 'Calculos/CalcularPiscinaAquario', entidade)
          .then(function (response) {
            return response;
          });
    }

    function buscarTiposCalculoPiscinaAquario() {
      return $http.get(API.URL + 'Calculos/BuscarTiposCalculoPiscinaAquario')
          .then(function (response) {
            return response;
          });
    }

    function calcularEspessuraBox(entidade) {
      return $http.post(API.URL + 'Calculos/CalcularEspessuraBox', entidade)
          .then(function (response) {
            return response;
          });
    }

    function calcularEspessuraEspelho(entidade) {
      return $http.post(API.URL + 'Calculos/CalcularEspessuraEspelho', entidade)
          .then(function (response) {
            return response;
          });
    }

    function calcularEspessuraTampo(entidade) {
      return $http.post(API.URL + 'Calculos/CalcularEspessuraTampo', entidade)
          .then(function (response) {
            return response;
          });
    }

    function calcularPrateleira(entidade) {
      return $http.post(API.URL + 'Prateleiras', entidade)
          .then(function (response) {
            return response;
          });
    }

    function buscarTipoCalculoPrateleira() {
      return $http.get(API.URL + 'Prateleiras/CalculosTipos')
          .then(function (response) {
            return response;
          });
    }


    return factory;
  }

})();

(function () {
  'use strict';

  angular
    .module('espessura', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngLodash',

      'ui.router',
      'ui.bootstrap',
      'ui.select',
      'ui.checkbox',
      'leaflet-directive',
      'anim-in-out',
      'toastr',
      'wt.responsive',
      'mgo-angular-wizard',
      'ui.utils.masks',
        'ui.mask',

      'common',
      'view',
      'cebraceCredito.filter'

    ]);

})();

(function () {
    'use strict';

    angular
        .module('espessura')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $log, RouteDefinitionService, toastr, LoadingService) {

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            angular.element('body').stop().animate({scrollTop: 0}, '200', 'swing', function () {

            });
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            RouteDefinitionService.paramsStateAnterior = fromState.name;
        });

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            console.error(error);
        });

        $rootScope.toastr = toastr;

        LoadingService.loader.esconder();
    }

})();

(function () {
    'use strict';

    angular
        .module('espessura')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app', {
                url: '',
                abstract: true,
                views: {
                }
            })
            .state('app.home', {
                url: '/',
                views: {
                    '@': {
                        templateUrl: 'app/view/main/main.tpl.html',
                        controller: 'MainController',
                        controllerAs: 'vm'
                    }
                }
            });

        $urlRouterProvider.otherwise('/');
    }

})();

(function () {
    'use strict';

    angular.module('cebraceCredito.filter', [])
        .filter('porcentagem', FiltroPorcentagem)
        .filter('split', FiltroSplit);

    function FiltroPorcentagem($filter) {
        return function (input, decimals) {
            if (input > 0){
                return $filter('number')(input * 100, decimals) + ' %';
            }
            else {
                return '0 %';
            }
        };
    }
    function FiltroSplit (input, splitChar, splitIndex) {
        return input.split(splitChar)[splitIndex];
    }
})();

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular
        .module('espessura')
        .constant('malarkey', malarkey)
        .constant('moment', moment)
        .constant('API', {
          // 'URL': 'http://localhost:56050/api/' //Local
          //'URL': 'http://sistemas_qa.cebrace.com.br/CalculoEspessura.WebAPI/api/' //QA
           'URL': 'http://www.cebrace.com.br/CalculoEspessura.WebAPI/api/' // PRD
        });

})();

(function() {
  'use strict';

  angular
    .module('espessura')
    .factory('AppInterceptor', AppInterceptor)
    .config(config);

  /** @ngInject */
  function AppInterceptor($q, $rootScope) {

    var toastr = $rootScope.toastr;
    var toastInterval = setInterval(function () {
      if (toastr) {
        clearInterval(toastInterval);
      }
      toastr = $rootScope.toastr;
    });

    return {
      request: function (res) {
        return res;
      },

      requestError: function (res) {
        return $q.reject(res);
      },

      response: function (res) {
        var _res = res;

        if (res.data && res.data.ShowToast) {
          angular.element(res.data.Messages).each(function (iM, message) {
            toastr.success(message, res.data.Title);
          });
        }

        if (res.data && res.data.Data) {
          _res = angular.copy(res.data.Data);
        }
        
        return _res;
      },

      responseError: function (res) {
        var _res = res;
        if (res.data.Data) {
          _res = res.data.Data;
        }
        if (res.data.ShowToast) {
          angular.element(res.data.Messages).each(function (iM, message) {
            toastr.error(message, res.data.Title);
          });
        }
        if (res.data.Error) {
          console.error(res.data.Error.Message, res.data.Error.Message);
        }
        return $q.reject(_res);
      }
    }
  }

  /** @ngInject */
  function config($logProvider, $httpProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 7000;
    toastrConfig.positionClass = 'toast-top-right';
    //toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // Declare the Interceptor
    $httpProvider.interceptors.push('AppInterceptor');
  }

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.selecao.objetivo',
            [
                'visor.piscina.selecao.objetivo.controller',
                'selecao-objetivo.service'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('visor.piscina.passo.a.passo',
            [
                'visor.piscina.primeiro.passo',
                'visor.piscina.segundo.passo',
                'visor.piscina.terceiro.passo',
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('tampo.passo.a.passo',
            [
                'tampo.primeiro.passo',
                'tampo.segundo.passo',
                'tampo.terceiro.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('pressao.vento.passo.a.passo',
            [
                'pressao.vento.primeiro.passo',
                'pressao.vento.segundo.passo',
                'pressao.vento.terceiro.passo',
                'pressao.vento.quarto.passo',
                'pressao.vento.quinto.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('prateleira.passo.a.passo',
            [
                'prateleira.primeiro.passo',
                'prateleira.segundo.passo',
                'prateleira.terceiro.passo',
                'prateleira.quarto.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('piso.vidro.passo.a.passo',
            [
                'piso.vidro.primeiro.passo',
                'piso.vidro.segundo.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('espelho.passo.a.passo',
            [
                'espelho.primeiro.passo',
                'espelho.segundo.passo',
                'espelho.terceiro.passo'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('box.passo.a.passo',
            [
                'box.primeiro.passo',
                'box.segundo.passo',
                'box.terceiro.passo',
                'box.quarto.passo',
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('selecao.vidro',
            [
                'selecao.vidro.controller',
                'selecao.vidro.service'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('main',
            [
               'main.controller'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('barra.progresso',
            [
                'barra.progresso.controller',
                'barra.progresso.service'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('common.service',
            [
                'route-definition.service',
                'model.service',
                'calculo-espessura.service',
                'loading.service'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('common.filter',
            [
                'unidade.filter',
                'numero-telefone.filter'
            ]
        );

})();

(function () {
  'use strict';

  angular
    .module('common.factory',
      [
        'vidro.factory',
        'local.factory',
        'calculo.factory',
        'regra.factory'
      ]
    );

})();

(function () {
    'use strict';

    angular
        .module('common.directive',
            [
                'vidro-dctv.directive'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('view',
            [
                'main',
                'pressao.vento',
                'piso.vidro',
                'visor.piscina',
                'selecao.vidro',
                'barra.progresso',
                'configuracao',
                'box',
                'espelho',
                'tampo',
                'prateleira'
            ]
        );

})();

(function () {
    'use strict';

    angular
        .module('common',
            [
                'common.service',
                'common.factory',
                'common.directive',
                'common.filter'
            ]
        );

})();

angular.module("espessura").run(["$templateCache", function($templateCache) {$templateCache.put("app/view/barra-progresso/barra-progresso.tpl.html","<ul class=my-steps><li ng-class=\"{\'active\':pass.selecionado}\" ui-sref={{pass.state}} title={{pass.titulo}} style=\"width:calc((100% / {{vm.BarraProgressoService.passos.length}}) - ({{vm.BarraProgressoService.passos.length}}*1vw))\" ng-repeat=\"pass in vm.BarraProgressoService.passos\"><i class=\"fa fa-circle\"></i><div>{{pass.titulo}}</div></li></ul>");
$templateCache.put("app/view/main/main.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre</h4>O Software de Cálculo Cebrace é uma ferramenta de especificação destinada a calcular as espessuras de vidros aplicados em fachadas, cobertura, visores de piscina, aquários e pisos de vidro, de propriedade da Cebrace, desenvolvido de acordo com as normas brasileiras ABNT NBR 7199 e NBR 6123. Segue conjuntamente algumas recomendações da norma francesa da DTU - 39. O resultado fornecido por esta ferramenta leva em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, a Cebrace não se responsabiliza por quaisquer erros, omissões ou imprecisões nas informações prestadas pelo usuário. Em caso de dúvida, contatar o Departamento Técnico Cebrace nos números 0800 72 VIDRO (0800 72 84376). A Cebrace reserva-se o direito de modificar e/ou alterar o presente software sempre que necessário, com o intuito de garantir ao usuário a adequação ao texto da Norma pertinente.</div></div></div><div class=row style=\"overflow-y: hidden;overflow-x: hidden\"><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=pressao-vento.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Pressão do Vento</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-angle-double-right animate\" aria-hidden=true style=\"color: green;font-size: 30px\"></i></h4></div></div><p class=text-justify>Bem vindo à ferramenta Cebrace de Dimensionamento de vidros aplicados em fachadas e coberturas.</p><p class=text-justify>Esta ferramenta tem como objetivo auxiliar os clientes Cebrace assim como os projetistas no dimensionamento de vidros para fachadas e coberturas. Você passará por três passos até obter o resultado. Tenha em mãos informações como local da obra, dimensões da edificação, tipo de vidro a ser utilizado e suas dimensões e detalhes de aplicação.</p></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=piso-vidro.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Piso de Vidro</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-clone animate\" aria-hidden=true style=\"color: #00AA88;font-size: 30px\"></i></h4></div></div><p>Descrição Aqui</p></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=visor-piscina.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Visores de Piscina e Aquário</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-life-saver animate\" style=\"color: red;font-size: 30px\" aria-hidden=true></i></h4></div></div><p>Descrição Aqui</p></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=box.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Box de Vidro</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-life-saver animate\" style=\"color: red;font-size: 30px\" aria-hidden=true></i></h4></div></div><p>Descrição Aqui</p></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=espelho.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Espelhos</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-life-saver animate\" style=\"color: red;font-size: 30px\" aria-hidden=true></i></h4></div></div><p>Descrição Aqui</p></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=tampo.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Tampos de Vidro</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-life-saver animate\" style=\"color: red;font-size: 30px\" aria-hidden=true></i></h4></div></div><p>Descrição Aqui</p></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 icon-menu\" ui-sref=prateleira.primeiro-passo style=\"cursor: pointer\"><div class=\"bs-callout bs-callout-cebrace\"><div class=\"row bs-bar-title\"><div class=\"col-xs-8 left\"><h4><span>Prateleiras</span></h4></div><div class=\"col-xs-4 right\"><h4><i class=\"fa fa-life-saver animate\" style=\"color: red;font-size: 30px\" aria-hidden=true></i></h4></div></div><p>Descrição Aqui</p></div></div></div></div>");
$templateCache.put("app/view/selecao-vidro/selecao-vidro.tpl.html","<div class=\"col-xs-12 col-md-6\"><label class=control-label>Lado do Vidro</label><ui-select ng-model=vm.crudTopografia ng-disabled=!vm.SelecaoObjetivoService.podeAlterar><ui-select-match placeholder=\"Lado do Vidro\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.name as item in vm.sourceVidro\"><span ng-bind=item.name></span></ui-select-choices></ui-select></div>");
$templateCache.put("app/common/directive/vidro-dctv/vidro-dctv.tpl.html","<div class=\"panel panel-default\"><div class=panel-heading style=\"padding: 4px\"><div class=row style=\"margin-bottom: 0px\"><div class=\"col-xs-12 col-sm-8\"><span>Vidro</span></div><div class=\"col-xs-12 col-sm-4 text-right\"><button class=\"btn btn-xs btn-default\" ng-if=\"selecionados.vidro.Composicoes.length>0\" ng-click=alternarCollapse()><i class=fa ng-class=\"{\'fa-angle-double-up\':!collapse,\'fa-angle-double-down\':collapse}\"></i></button></div></div></div><div class=panel-body style=\"padding: 4px\"><div class=\"row row-composicao\"><div class=\"col-xs-12 vcenter\" style=\"padding: 0px\" ng-class=\"{\'col-md-4\':existeInsulado(),\'col-md-6\':!existeInsulado()&&existeLaminado(),\'col-md-12\':!existeInsulado()&&!existeLaminado()}\"><div class=row style=width:100%><div class=\"col-xs-12 form-group\"><ui-select ng-model=selecionados.composto on-select=aoSelecionarComposto($select.selected) search-enabled=false><ui-select-match placeholder=Composição><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item in composicoes\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div><div class=col-xs-12><ui-select ng-model=selecionados.vidro on-select=aoSelecionarVidro($select.selected) search-enabled=false><ui-select-match placeholder=Vidro><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item in selecionados.composto.Vidros\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div></div><div class=col-xs-12 ng-if=\"selecionados.vidro.Composicoes.length>0\" ng-class=\"{\'col-md-8\':existeInsulado(),\'col-md-6\':!existeInsulado()&&existeLaminado()}\"><div class=row uib-collapse=collapse><div class=col-xs-12><hr-title>Composições</hr-title></div><div class=col-xs-12 ng-repeat=\"composicao in selecionados.vidro.Composicoes\"><vidro-dctv style=\"margin-bottom: 5px\" composicoes=selecionados.composto.Composicoes composicao-mae=composicao></vidro-dctv></div></div></div></div></div></div>");
$templateCache.put("app/view/box/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo de Box de Vidro</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Calculo de Box de Vidro.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/configuracao/regra/regra.tpl.html","<div id=terceiro-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>Regras</h4><p>Configure as regras do sistema.</p></div></div></div><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=col-xs-6><label class=\"control-label pull-left\">Descrição</label></div><div class=col-xs-3><label class=\"control-label pull-left\">Valor</label></div><div class=col-xs-2><label class=\"control-label pull-left\">Status</label></div><div class=col-xs-1></div><div class=col-xs-12><hr></div></div><div class=row ng-repeat=\"regra in vm.sourceRegras\"><div class=col-xs-6>{{regra.Descricao}}</div><div class=col-xs-3>{{regra.Valor}}</div><div class=col-xs-2>{{regra.Ativo ? \'Ativo\' : \'Inativo\'}}</div><div class=col-xs-1><button ng-click=vm.editarRegra(regra) class=\"btn btn-warning pull-left\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span></button></div><div class=col-xs-12 ng-if=!$last><hr></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button></div></div></div><div class=\"modal fade\" id=ModalEditarRegra role=dialog aria-labelledby=EditarRegra aria-hidden=true><div class=\"modal-dialog modal-lg\" role=document><div class=modal-content><div class=modal-header><h4 class=modal-title>Editar Regra</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=well>{{vm.regraEdicao.Descricao}}</div></div></div><div class=row><div class=col-xs-12><label>Chave</label><input class=form-control placeholder=Chave ng-model=vm.regraEdicao.Chave></div></div><div class=row><div class=col-xs-12><label>Valor</label><input class=form-control placeholder=Valor ng-model=vm.regraEdicao.Valor></div></div><div class=row><div class=col-xs-12><label>Mensagem <small>(exibida quando ocorre erro com a regra)</small></label><input class=form-control placeholder=Mensagem ng-model=vm.regraEdicao.Mensagem></div></div><div class=row><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=vm.regraEdicao.Ativo> Ativo</label></div></div></div><div class=row><div class=col-xs-12><small>Data Criação: {{vm.regraEdicao.DataCriacao | date : \'dd/mm/yyyy\'}}</small></div></div><div class=row><div class=col-xs-12><small>Última Alteração: {{vm.regraEdicao.DataAlteracao | date : \'dd/mm/yyyy\'}}</small></div></div></div><div class=modal-footer style=\"text-align: right\"><button type=button class=\"btn btn-success\" ng-click=vm.confirmarEdicao(vm.regraEdicao)>Salvar</button> <button type=button class=\"btn btn-default\" data-dismiss=modal>Fechar</button></div></div></div></div>");
$templateCache.put("app/view/espelho/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo de Espelho</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Calculo de Espelho.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/piso-vidro/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo para Piso de Vidro</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Bem vindo a ferramenta de cálculo Cebrace para pisos de vidro! Antes de iniciar sua simulação é importante destacar que, quando utilizado como piso, o vidro a ser aplicado deverá ser obrigatoriamente um vidro laminado. Para fazer sua simulação é necessário que tenha a mão as dimensões do piso e a aplicação que se destina. Em caso de pisos circulares ou modelados, considerar com dimensão de simulação o retângulo ou quadrado que circunda a peça em questão. Esta ferramenta avalia somente situações aonde o piso será apoiado em todo o seu perímetro.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/prateleira/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo de Prateleiras</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Calculo de Prateleiras.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/pressao-vento/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo para Pressão do Vento</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Esta ferramenta tem como objetivo auxiliar os clientes Cebrace assim como os projetistas no dimensionamento de vidros para fachadas e coberturas. Você passará por 3 passos até obter o resultado. Tenha a mão informações como local da obra, dimensões da edificação, tipo de vidro a ser utilizado e suas dimensões e detalhes de aplicação. A memória de calculo desta ferramenta está de acordo com as Normas Brasileiras NBR7199 e NBR6123.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/tampo/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo de Tampos de Vidro</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Calculo de Tampos de Vidro.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/visor-piscina/apresentacao/apresentacao.tpl.html","<div class=container-fluid style=\"text-align: center\"><div class=row><div class=col-xs-12><div class=row><h1 style=\"color: #F5A35A\">Calculo de Visor de Piscina e Aquário</h1></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-md-4 vcenter opacity0\"><img src=assets/images/vidros-temperados.png class=\"img-responsive img-rounded\" alt=\"Responsive image\"></div><div class=\"col-xs-12 col-md-8 vcenter\"><div class=\"bs-callout bs-callout-cebrace\"><h4>Sobre a Ferramenta</h4><p>Antes de iniciar sua simulação é importante destacar que, quando aplicado como visor, o vidro a ser utilizado deverá ser obrigatoriamente um vidro laminado. Para fazer sua simulação é necessário que tenha a mão algumas informações como as dimensões das peças, o local de sua aplicação (no fundo do visor ou nas paredes laterais do mesmo) além de, em alguns casos, da coluna de água presente acima da peça de vidro. Em caso de aquários circulares ou modelados, considerar com dimensão de simulação o retângulo ou quadrado que circunda a peça em questão. Esta ferramenta avalia somente situações onde as peças estejam apoiadas em todo o seu perímetro ou com a borda superior livre. Para iniciar a simulação escolha uma das opções clicando sobre a figura.</p></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin-bottom: 20px\"><button ui-sref=app.home class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Iniciar</button></div></div></div>");
$templateCache.put("app/view/visor-piscina/selecao-objetivo/selecao-objetivo.tpl.html","<div class=\"col-xs-12 col-md-6\"><label class=control-label>Objetivo do Calculo</label><ui-select ng-model=vm.crudTopografia ng-disabled=!vm.SelecaoObjetivoService.podeAlterar><ui-select-match placeholder=\"Objetivo do Calculo\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.name as item in vm.sourceObjetivo\"><span ng-bind=item.name></span></ui-select-choices></ui-select></div>");
$templateCache.put("app/view/box/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><p>Tipo de vidro e Tipo de estrutura.</p><p style=\"color: red\">Por recomendação da NBR 14207, todas as peças do box devem ser do mesmo tipo, desta forma, primeiramente selecione o tipo de vidro e como será a estrutura do box para dar prosseguimento no dimensionamento das peças.</p></div></div></div></div></div><div class=row><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Selecione o tipo de vidro.</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><ui-select ng-model=vm.model.TipoVidro><ui-select-match placeholder=\"Tipo de Vidro\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item in vm.sourceTiposVidro\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div></div><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Selecione o tipo de estrutura.</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><ui-select ng-model=vm.model.TipoAplicacao ng-disabled=!vm.model.TipoVidro><ui-select-match placeholder=\"Tipo de Estrutura\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item as item in vm.model.TipoVidro.Aplicacoes\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div><style>.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {\r\n        text-align: center;\r\n    }</style>");
$templateCache.put("app/view/box/passo-a-passo/quarto-passo/quarto-passo.tpl.html","<div id=terceiro-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>6.</h4><p>Resultados obtidos.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Espessura de Vidro</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Dados de Peças para Box</h3></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Relatório para</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Nome}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Telefone</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Telefone | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Empresa</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Empresa}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Fax</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Fax | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Obra</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Obra}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Email</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Email}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=col-xs-12><label>Box de {{vm.model.RelatorioFinal[0].TipoVidro}} com estrutura {{vm.model.RelatorioFinal[0].TipoAplicacao}}</label></div><div class=col-xs-12 ng-if=vm.model.RelatorioFinal[0].Observacao><label style=\"color: red !important\">{{vm.model.RelatorioFinal[0].Observacao}}</label></div></div><table class=table><thead><tr><th>Vidro</th><th>Tipo de Peça</th><th>Altura (em metros)</th><th>Largura (em metros)</th><th>Espessura Recomendada (em milímetros)</th></tr></thead><tbody class=table-striped><tr ng-repeat=\"peca in vm.model.RelatorioFinal\"><td>Vidro {{$index + 1}}</td><td>{{peca.TipoPeca}}</td><td>{{peca.Altura | number: 2}}</td><td>{{peca.Largura | number: 2}}</td><td><b>{{peca.Espessura | number: 2}}</b></td></tr></tbody></table></div></div><div class=\"row footer\"><div class=col-xs-12><p>Segundo NBR 14207 de 2009, deve-se evitar o contato entre o vidro e outros materiais que possam danificá-lo, colocando-se entre eles materiais imputrescíveis que protejam sua superfície.</p><p>Todo furo e recorte feito no vidro deve ter uma proteção feita com materiais não higroscópicos e imputrescíveis, que evite o contato das bordas das chapas de vidro entre si, e com alvenaria ou peças metálicas.</p><p>Caso seja feita aplicação de película de segurança, esta deve ser instalada do lado externo do box. A instalação deve garantir o ancoramento da película de segurança, garantindo a segurança do sistema com vidro temperado quebrado. Para isso a película deve ser instalada sob a fixação das roldanas e, no caso da porta de abrir, a película de segurança deve ser instalada sob a dobradiça.</p><p>A presente ferramenta de cálculo fornece as espessuras mínimas de cada peça de vidro, calculada de forma independente, cabendo ao usuário a escolha da espessura de aplicação do sistema.</p></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.imprimir() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/box/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>5.</h4><p>Informar dados do solicitante para emissão do relatório.</p></div></div></div><div class=\"row print-enabled\"><div class=\"col-xs-12 print-content\"><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-10 col-xs-offset-1 col-sm-10\"><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Relatório para</label><input type=text ng-model=vm.model.Nome class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Telefone</label><input type=text ng-model=vm.model.Telefone class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Empresa</label><input type=text ng-model=vm.model.Empresa class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Fax</label><input type=text ng-model=vm.model.Fax class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Obra</label><input type=text ng-model=vm.model.Obra class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Email</label><input type=text ng-model=vm.model.Email class=form-control></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados Fornecidos</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><img src={{vm.model.TipoVisor.imgSrcSelecionado}} style=\"max-width: 100%\"></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Nome}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Largura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Altura}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura d\'água</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Largura}}</span></div></div></div></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-12\" style=\"overflow-x: scroll\"><table class=\"table table-bordered table-striped\" style=\"max-width: 100%\" wt-responsive-table><thead><tr><th>Tipo de Vidro</th><th>2 Lâminas</th><th>3 Lâminas</th><th>4 Lâminas</th></tr></thead><tbody><tr><td><span>Laminado Comum</span></td><td><span><b>19+19=38 mm</b></span></td><td><span><b>15+15+15=45 mm</b></span></td><td><span><b>12+12+12+12=48 mm</b></span></td></tr><tr><td><span>Laminado Temperado</span></td><td><span><b>10+10=20 mm</b></span></td><td><span><b>8+8+8=24 mm</b></span></td><td><span><b>6+6+6+6=24 mm</b></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.calcular() class=\"btn btn-success pull-right\">Calcular</button></div></div></div>");
$templateCache.put("app/view/box/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><p>Tipo da Peça e Dimensões.</p><p>Selecione qual peça e suas dimensões para recomendação de espessura e clique em adicionar para calcular o restante das peças do projeto.</p></div></div></div></div></div><div class=row><div class=\"col-xs-12 text-center\" ng-if=\"vm.model.Pecas && vm.model.Pecas.length > 0\"><table class=table><thead><tr><th></th><th>Tipo Peça</th><th>Tipo Vidro</th><th>Tipo Encaixe</th><th>Altura</th><th>Largura</th></tr></thead><tbody class=table-striped><tr ng-repeat=\"peca in vm.model.Pecas\"><td><button ng-click=vm.removerPeca(peca) class=\"btn btn-danger\">Excluir</button></td><td>{{peca.tipoPeca.Descricao}}</td><td>{{peca.tipoVidro.Descricao}}</td><td>{{peca.tipoAplicacao.Descricao}}</td><td>{{peca.altura | number: 2}} metros</td><td>{{peca.largura | number: 2}} metros</td></tr></tbody></table></div><div class=\"col-xs-12 text-center\" ng-if=\"!vm.model.Pecas || vm.model.Pecas.length == 0\"><p>Nenhum item adicionado. Adicione para prosseguir.</p></div></div><div class=row><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>3.</h4><p>Selecione o tipo de peça.</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><ui-select ng-model=vm.modeloPeca.tipoPeca><ui-select-match placeholder=\"Tipo de Peça\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item in vm.sourceTiposPeca\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div></div><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>4.</h4><p>Quais as dimensões da peça?</p></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=text ng-model=vm.modeloPeca.altura class=form-control placeholder=\"Altura (H) em metros\" ui-number-mask></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=text ng-model=vm.modeloPeca.largura class=form-control placeholder=\"Largura (L) em metros\" ui-number-mask></div></div></div><div class=row><div class=\"col-xs-2 col-xs-offset-5\" style=\"text-align: center\"><button ng-click=vm.adicionarPeca() class=\"btn btn-success\" ng-disabled=!vm.validarPeca()>Adicionar</button></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div><style>.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {\r\n        text-align: center;\r\n    }</style>");
$templateCache.put("app/view/espelho/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Informar dados do solicitante para emissão do relatório.</p></div></div></div><div class=\"row print-enabled\"><div class=\"col-xs-12 print-content\"><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-10 col-xs-offset-1 col-sm-10\"><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Relatório para</label><input type=text ng-model=vm.model.Nome class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Telefone</label><input type=text ng-model=vm.model.Telefone class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Empresa</label><input type=text ng-model=vm.model.Empresa class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Fax</label><input type=text ng-model=vm.model.Fax class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Obra</label><input type=text ng-model=vm.model.Obra class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Email</label><input type=text ng-model=vm.model.Email class=form-control></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados Fornecidos</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><img src={{vm.model.TipoVisor.imgSrcSelecionado}} style=\"max-width: 100%\"></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Nome}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Largura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Altura}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura d\'água</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Largura}}</span></div></div></div></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-12\" style=\"overflow-x: scroll\"><table class=\"table table-bordered table-striped\" style=\"max-width: 100%\" wt-responsive-table><thead><tr><th>Tipo de Vidro</th><th>2 Lâminas</th><th>3 Lâminas</th><th>4 Lâminas</th></tr></thead><tbody><tr><td><span>Laminado Comum</span></td><td><span><b>19+19=38 mm</b></span></td><td><span><b>15+15+15=45 mm</b></span></td><td><span><b>12+12+12+12=48 mm</b></span></td></tr><tr><td><span>Laminado Temperado</span></td><td><span><b>10+10=20 mm</b></span></td><td><span><b>8+8+8=24 mm</b></span></td><td><span><b>6+6+6+6=24 mm</b></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.calcular() class=\"btn btn-success pull-right\">Calcular</button></div></div></div>");
$templateCache.put("app/view/espelho/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html","<div id=quinto-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>3.</h4><p>Resultados obtidos.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Espessura de Espelho</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Dados do Vidro</h3></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Relatório para</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Nome}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Telefone</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Telefone | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Empresa</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Empresa}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Fax</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Fax | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Obra</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Obra}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Email</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Email}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados do Vidro</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.altura | number: 2}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Largura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.largura | number: 2}} metro(s)</span></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Cálculo</h3></div></div><div class=row><div class=col-xs-12 ng-if=vm.model.RelatorioFinal.Aprovado><label>Espessura Recomendada</label><span>{{vm.model.RelatorioFinal.Espessura | number: 2}} mm</span></div><div class=col-xs-12 ng-if=!vm.model.RelatorioFinal.Aprovado><label style=\"color: red\">{{vm.model.RelatorioFinal.Mensagem}}</label></div></div></div></div><div class=\"row footer\"><div class=col-xs-12><p>Segundo NBR 15198 de 2005 o substrato onde o espelho será instalado deve ser plano, a fim de não permitir distorção óptica; possuir isolamento quanto à umidade; e ter resistência mecânica suficiente para suportar o espelho.</p><p>Para uma boa instalação, recomenda-se que entre o espelho e o substrato exista um espaçamento de, no mínimo, 3mm, permitindo a circulação de ar; Quando mais de um espelho é fixado na mesma superfície, deve ser assegurado que exista uma folga mínima entre as bordas. Um separador de 1 mm pode ser utilizado para este propósito; Espelhos utilizados em saunas, banheiros, piscinas, ou em quaisquer ambientes que tenham um alto índice de umidade ou atmosfera corrosiva, são propensos à oxidação;</p><p>Além disso, para instalação recomenda-se que os filetes sejam sempre na vertical, de modo a permitir o fluxo de ar de baixo para cima. Não deve ser utilizado qualquer cola que contenha solventes orgânicos e/ou componentes ácidos, como colas de sapateiro, cola de fórmica, cola de carpete etc. Esses adesivos são corrosivos e provocam sérios riscos a segurança da montagem e durabilidade dos espelhos, além de conterem solventes tóxicos. A colagem mais eficiente e menos agressiva ao revestimento do espelho é realizada com adesivos elastoméricos neutros, como o Fixa Espelho Cebrace e o Protetor de Borda.</p></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.imprimir() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/espelho/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Quais as dimensões do espelho?</p></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=text ng-model=vm.model.altura class=form-control placeholder=\"Altura (H) em metros\" ui-number-mask></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=text ng-model=vm.model.largura class=form-control placeholder=\"Largura (L) em metros\" ui-number-mask></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/piso-vidro/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Inserir os valores dos lados do piso.</p></div></div></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-sm-6\"><img style=\"width: 600px;max-width: 100%\" src=assets/images/tipo-vidro/chapa-piso-vidro.png></div><div class=\"col-xs-12 col-sm-6 vcenter\"><div class=row style=width:100%><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\"><input class=form-control ng-model=vm.crudEdificacao.MaiorDimensao placeholder=\"Menor Dimensão (H1)\"></div></div><div class=row><div class=\"col-xs-12 form-group\"><input class=form-control ng-model=vm.crudEdificacao.MenorDimensao placeholder=\"Menor Dimensão (L1)\"></div></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Selecionar a topografia do terreno clicando sobre os desenhos que representam as topografias de terreno possíveis.</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12\"><ui-select ng-model=vm.crudVidro.Nome><ui-select-match placeholder=Local><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.name as item in vm.sourceLocais\"><span ng-bind=item.name></span></ui-select-choices></ui-select></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/piso-vidro/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>Passo 2</h4><ol><li style=\"text-align: left\">Preencha todos os campos de informação.</li><li style=\"text-align: left\">Selecione as informações que deseja retirar do relatório nos campos de check (nos dados da Região).</li><li style=\"text-align: left\">Clique em “Imprimir” para obter o relatório impresso.</li></ol></div></div></div><div class=\"row print-enabled\"><div class=\"col-xs-12 print-content\"><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Relatório para</label><input type=text class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Telefone</label><input type=text class=form-control></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Empresa</label><input type=text class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Fax</label><input type=text class=form-control></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Obra</label><input type=text class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Email</label><input type=text class=form-control></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados Fornecidos</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Maior Lado</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">###################</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Menor Lado</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">###################</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Local</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">###################</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Carga distribuida</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">###################</span></div></div></div></div></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-12\" style=\"overflow-x: scroll\"><table class=\"table table-bordered table-striped\" style=\"max-width: 100%\" wt-responsive-table><thead><tr><th>Tipo de Vidro</th><th>2 Lâminas</th><th>3 Lâminas</th><th>4 Lâminas</th></tr></thead><tbody><tr><td><span>Laminado Comum</span></td><td><span><b>19+19=38 mm</b></span></td><td><span><b>15+15+15=45 mm</b></span></td><td><span><b>12+12+12+12=48 mm</b></span></td></tr><tr><td><span>Laminado Temperado</span></td><td><span><b>10+10=20 mm</b></span></td><td><span><b>8+8+8=24 mm</b></span></td><td><span><b>6+6+6+6=24 mm</b></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button onclick=window.print() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/prateleira/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Selecione o tipo de Cálculo.</p></div></div></div><div class=row><div style=\"margin-bottom: 1em\" class=\"col-xs-12 text-center\"><div class=\"col-xs-6 col-sm-6 prateleira-tipo-grid\" ng-repeat=\"formaPrateleira in vm.formasPrateleira\"><div><img ng-if=\"formaPrateleira === \'Retangular\'\" style=\"margin-left: 4em; max-width: 150%\" src=assets/images/tipo-vidro/prateleira-retangular.jpg> <img ng-if=\"formaPrateleira === \'Não Retangular\'\" style=\"margin-left: 5em; max-width: 150%\" src=assets/images/tipo-vidro/prateleira-nao-retangular.jpg><p style=\"margin-left: 18em\">{{ formaPrateleira }}</p><button ng-click=\"vm.model.isRetangular = vm.eRetangular(formaPrateleira);\" class=\"btn btn-default\" style=\"margin-left: 18em\" ng-class=\"vm.model.isRetangular === vm.eRetangular(formaPrateleira)? \'btn-success\' : \'btn-default\'\">Selecionar</button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Preciso descobrir:</p></div></div><div class=row><div class=\"col-xs-12 text-center\"><div class=\"col-xs-6 col-sm-6 prateleira-tipo-grid\" ng-repeat=\"tipoCalculo in vm.tiposCalculo\"><div><img ng-if=\"tipoCalculo.Valor === \'ESPES\'\" style=\"margin-left: 5em; max-width: 150%\" src=assets/images/tipo-vidro/prateleira-espessura.jpg> <img ng-if=\"tipoCalculo.Valor === \'CRGMX\'\" style=\"margin-left: 5em; max-width: 150%\" src=assets/images/tipo-vidro/prateleira-calculo-peso.jpg><p style=\"margin-left: 18em\">{{ tipoCalculo.Descricao }}</p><button ng-click=\"vm.model.tipoCalculoId = tipoCalculo.Id;\" class=\"btn btn-default\" style=\"margin-left: 18em\" ng-class=\"vm.model.tipoCalculoId === tipoCalculo.Id ? \'btn-success\' : \'btn-default\'\">Selecionar</button></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"bs-callout bs-callout-cebrace\"><h4>3.</h4><p>Sua prateleira está 100% apoiada?</p></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"bs-callout bs-callout-cebrace\"><h4>4.</h4><p>A peça possui furação?</p></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"col-xs-6 text-center\"><button ng-click=\"vm.model.isCemPorCentoApoiada = true;\" class=\"btn btn-default pull-left\" ng-class=\"vm.model.isCemPorCentoApoiada ? \'btn-success\' : \'btn-default\'\" style=\"margin-right: 2em; width: 30%\">Sim</button> <button ng-click=\"vm.model.isCemPorCentoApoiada = false;\" class=\"btn btn-default pull-left\" ng-class=\"vm.model.isCemPorCentoApoiada == false ? \'btn-success\' : \'btn-default\'\" style=\"width: 30%\">Não</button></div><div class=\"col-xs-6 text-center\"><button ng-click=\"vm.model.hasFuracao = true;\" class=\"btn btn-default pull-left\" ng-class=\"vm.model.hasFuracao ? \'btn-success\' : \'btn-default\'\" style=\"margin-right: 2em; width: 30%\">Sim</button> <button ng-click=\"vm.model.hasFuracao = false;\" class=\"btn btn-default pull-left\" ng-class=\"vm.model.hasFuracao == false ? \'btn-success\' : \'btn-default\'\" style=\"width: 30%\">Não</button></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div></div>");
$templateCache.put("app/view/prateleira/passo-a-passo/quarto-passo/quarto-passo.tpl.html","<div id=terceiro-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>8.</h4><p>Resultados obtidos.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Prateleira</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Cálculo de {{ vm.model.TipoCalculo }}</h3></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Relatório para</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Nome}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Telefone</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Telefone | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Empresa</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Empresa}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Fax</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Fax | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Obra</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Obra}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Email</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Email}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados</h3></div></div><div class=row><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Largura da peça</label></div><div class=col-xs-6><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.LarguraPeca | number: 2}} mm</span></div></div></div><div class=row><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Área da peça</label></div><div class=col-xs-6><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.AreaPeca | number: 2}} m²</span></div></div></div><div class=row><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Distância entre apoios</label></div><div class=col-xs-6><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.DistanciaApoio}}</span></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Considerado</h3></div></div><div class=row><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Prateleira está 100% apoiada?</label></div><div class=col-xs-6><span class=\"control-label pull-left\">{{ vm.model.IsCemPorCentoApoiada ? \'Sim\' : \'Não\' }}</span></div></div></div><div class=row><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Peça possui furação?</label></div><div class=col-xs-6><span class=\"control-label pull-left\">{{ vm.model.HasFuracao ? \'Sim\' : \'Não\' }}</span></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Cálculo</h3></div></div><div class=row ng-show=vm.model.TipoVidro><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Tipo de vidro</label></div><div class=col-xs-6><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.TipoVidro}}</span></div></div></div><div class=row ng-show=vm.model.Espessura><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Espessura da peça</label></div><div class=col-xs-6><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.Espessura}}</span></div></div></div><div class=row ng-if=\"vm.calculoId === 2\"><div class=col-xs-12><div class=col-xs-6><label class=\"control-label pull-left\">Carga máxima</label></div><div class=col-xs-6><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.CargaMaxima}} kg/m²</span></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Observação</h3></div></div><div class=row><div class=col-xs-12>Caso a peça de vidro possua furação para fixação, o vidro é considerado autoportante e obrigatoriamente dever ser temperado.</div></div><br><div class=row><div class=col-xs-12>As informações contidas nesse formulário foram baseadas na norma brasileira ABNT NBR 14564/2017 e são para assistência na aplicação dos vidros CEBRACE, no entanto levam em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, A CEBRACE NÃO SE RESPONSABILIZA POR QUAISQUER ERROS, OMISSÕES OU IMPRECISÕES NAS INFORMAÇÕES PRESTADAS PELO USUÁRIO. Portanto, este documento não deve ser utilizado como memorial de cálculo e sim como uma ferramenta de especificação e auxílio na aplicação de vidros planos CEBRACE. O cliente declara que se responsabilizará perante quaisquer terceiros, por quaisquer atos e fatos oriundos da utilização dos produtos, inclusive no que diz respeito à emissão de ARTs e/ou RRTs quando se tratar de projetos.</div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.imprimir() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/prateleira/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>7.</h4><p>Complete com as informações</p></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados do Solicitante</h3></div></div><div class=row><div class=\"col-xs-10 col-xs-offset-1 col-sm-10\"><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Relatório para</label><input type=text ng-model=vm.model.nome class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Telefone</label><input type=text ng-model=vm.model.telefone class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Empresa</label><input type=text ng-model=vm.model.empresa class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Fax</label><input type=text ng-model=vm.model.fax class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Obra</label><input type=text ng-model=vm.model.obra class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Email</label><input type=text ng-model=vm.model.email class=form-control></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.calcular() class=\"btn btn-success pull-right\">Calcular</button></div></div></div>");
$templateCache.put("app/view/prateleira/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>5.</h4><p>Complete com as informações</p></div></div></div><div class=row><div class=col-xs-12><p>Qual o tipo de vidro?</p></div></div><div class=row><div class=col-xs-4><ui-select ng-model=vm.model.tipoVidroId on-select=vm.obterEspessuras(false)><ui-select-match placeholder=\"Tipo de Vidro\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item.Id as item in vm.sourceTiposVidro\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div><br><ng-container ng-show=\"vm.model.tipoCalculoId == 2\"><div class=row><div class=col-xs-12><p>Qual a espessura da peça?</p></div></div><div class=row><div class=col-xs-4><ui-select ng-model=vm.model.espessuraId on-select=vm.obterDistancia()><ui-select-match placeholder=\"Espessura da peça\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item.Id as item in vm.sourceEspessuras\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div><br></ng-container><div class=row><div class=col-xs-12><p>Qual a distância entre apoios?</p></div></div><div class=row><div class=col-xs-4><ui-select ng-model=vm.model.distanciaApoioId><ui-select-match placeholder=\"Distância entre apoios\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item.Id as item in vm.sourceDistanciaEntreApoios\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div><br><div class=row><div class=col-xs-12><p>Qual a largura da peça?</p></div></div><div class=row><div class=\"col-xs-4 div-mm mm\"><input type=text ng-model=vm.model.larguraPeca class=form-control placeholder=Largura ui-number-mask></div></div><ng-container ng-show=\"vm.model.tipoCalculoId == 1\"><br><div class=row><div class=col-xs-12><p>Qual a carga máxima?</p></div></div><div class=row><div class=\"col-xs-4 div-mm kgm2\"><input type=text ng-model=vm.model.cargaMaxima class=form-control placeholder=\"Carga máxima\" ui-number-mask></div></div></ng-container><br><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>6.</h4><p>Qual a área da peça?</p></div></div></div><div class=row><div class=\"col-xs-4 div-mm m2\"><input type=text ng-model=vm.model.areaPeca class=form-control placeholder=\"Área da peça\" ui-number-mask></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div></div>");
$templateCache.put("app/view/pressao-vento/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<script>function mascara(o,f){\r\n			v_obj=o\r\n			v_fun=f\r\n			setTimeout(\"execmascara()\",1)\r\n		}\r\n\r\n		function execmascara(){\r\n			v_obj.value=v_fun(v_obj.value)\r\n		}\r\n\r\n		function manual(v){\r\n			v=v.replace(/\\D/g,\"\")                    //Remove tudo o que não é dígito\r\n			v=v.replace(/(\\d{1})(\\d)/,\"$1.$2\")       //Coloca um ponto entre o terceiro e o quarto dígitos\r\n      v=v.replace(/(\\d{3})(\\d)/,\"$1,$2\")\r\n			return v\r\n		}</script><div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Selecionar Aplicação do Vidro.</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><label class=control-label style=\"display: block\">Aplicação do Vidro</label><div><label class=\"btn btn-cebrace-mixed\" style=\"margin-right: 25px\" ng-model=vm.PressaoVentoModel.AplicacaoVidroExterno uib-btn-radio=false>Interno</label><label class=\"btn btn-cebrace-mixed\" ng-model=vm.PressaoVentoModel.AplicacaoVidroExterno uib-btn-radio=true>Externo</label></div></div></div></div></div><div class=row ng-show=vm.PressaoVentoModel.AplicacaoVidroExterno><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Como deseja registrar a pressão de vento? Manualmente ou Cálcular pela NBR6123.</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><label class=control-label style=\"display: block\">Registrar Pressão de Vento</label><div><label class=\"btn btn-cebrace-mixed\" style=\"margin-right: 25px\" ng-model=vm.PressaoVentoModel.PressaoVentoManual uib-btn-radio=true>Manualmente</label><label class=\"btn btn-cebrace-mixed\" ng-model=vm.PressaoVentoModel.PressaoVentoManual uib-btn-radio=false>NBR6123</label></div></div></div><div class=row ng-show=vm.PressaoVentoModel.PressaoVentoManual><hr><div class=\"col-xs-12 text-center\"><label class=control-label style=\"display: block\">Digite o valor de pressão do vento:</label><div class=row><div class=\"col-xs-6 col-xs-offset-3 form-group\"><input type=text ng-model=vm.PressaoVentoModel.PressaoVento placeholder=\"Digite o valor de pressão do vento\" class=form-control onkeyup=mascara(this,manual)></div></div></div></div><div class=row ng-show=!vm.PressaoVentoModel.PressaoVentoManual><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>3.</h4><p>Selecionar a região aonde se encontra a obra clicando nas regiões descritas no mapa.</p></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=\"panel panel-default\"><div class=panel-heading>Regiões Eólicas</div><div class=panel-body style=\"padding: 0px\"><div class=container-fluid><div class=row ng-click=vm.selecionarRegiao(regiao) ng-class=\"{\'selecionada\':regiao.selecionada}\" style=\"border-bottom: 1px solid #ddd;padding: 2px 0px\" ng-repeat=\"regiao in vm.sourceRegioes\"><div class=col-xs-12><span class=pull-left>{{regiao.Titulo}}</span> <i class=\"fa fa-location-arrow pull-right\" style=\"color: {{regiao.Cor}}\"></i></div><div class=col-xs-12 uib-collapse=!regiao.selecionada><p ng-show=vm.selecionadoRegiao()>{{vm.selecionadoRegiao().Descricao}}</p></div></div></div></div></div></div><div class=\"col-xs-12 col-md-6\"><img style=\"width: 100%\" src=assets/images/eolica/mapa_eolica.jpg></div></div></div></div><div class=row ng-show=!vm.PressaoVentoModel.PressaoVentoManual><div class=\"col-xs-12 col-md-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>4.</h4><p>Selecionar a topografia do terreno clicando sobre os desenhos que representam as topografias de terreno possíveis.</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><ui-select ng-model=vm.PressaoVentoModel.Terreno.Topografia><ui-select-match placeholder=\"Topografia do Terreno\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item as item in vm.sourceTopografia\"><span ng-bind=item.Descricao></span><hr ng-if=!$last style=\"margin-top:10px; margin-bottom: 10px\"></ui-select-choices></ui-select></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>5.</h4><p>Selecionar a rugosidade do terreno clicando sobre os desenhos que representam as rugosidades de terreno possíveis.</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><ui-select ng-model=vm.PressaoVentoModel.Terreno.Rugosidade><ui-select-match placeholder=\"Rugosidade do Terreno\"><span ng-bind=$select.selected.DescricaoCategoria></span></ui-select-match><ui-select-choices repeat=\"item as item in vm.sourceRugosidade\"><span title={{item.DescricaoCategoria}} style=\"width: 100%;display: inline-block;white-space: normal\">{{item.DescricaoCategoria}}</span><hr ng-if=!$last style=\"margin-top:10px; margin-bottom: 10px\"></ui-select-choices></ui-select></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/pressao-vento/passo-a-passo/quinto-passo/quinto-passo.tpl.html","<div id=quinto-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>11.</h4><p>Resultados obtidos.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Espessura de Vidro</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Relatório para</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.Nome}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Telefone</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.Telefone | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Empresa</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.Empresa}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Fax</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.Fax | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Obra</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.Obra}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Email</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.Email}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados de Calculo da Pressão</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Pressão de Calculo</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.PressaoCalculo | number: 2}} Pa</span></div></div><!--<div class=\"row\">\r\n                <div class=\"col-xs-12 col-sm-6 col-print-6 form-group\">\r\n                  <label class=\"control-label pull-left\">Pressão Dinâmica</label>\r\n                </div>\r\n                <div class=\"col-xs-12 col-sm-6 col-print-6 form-group\">\r\n                  <span class=\"control-label pull-left\"> {{vm.PressaoVentoModel.RelatorioFinal.PressaoDinamica | number: 2}} Pa </span>\r\n                </div>\r\n              </div>--><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Pressão do Vento</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.PressaoVento | number: 2}} Pa</span></div></div></div></div><div class=row ng-if=\"vm.PressaoVentoModel.PressaoVentoManual == false\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados da Região</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Região Selecionada</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.AplicacaoVidroExterno ? vm.PressaoVentoModel.RelatorioFinal.Regiao : \'Aplicação Interna\'}}</span></div></div></div></div></div></div><div class=row ng-if=\"vm.PressaoVentoModel.PressaoVentoManual == false\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados do Edifício</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.AlturaEdificio}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Maior Dimensão</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.MaiorDimensaoEdificio | number: 2}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Menor Dimensao</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.MenorDimensaoEdificio | number: 2}} metro(s)</span></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados do Vidro</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Tipo do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\">{{vm.PressaoVentoModel.DadosVidro.Vidro.Descricao}}<ul ng-repeat=\"item in vm.PressaoVentoModel.DadosVidro.Vidro.Composicoes\">{{item.vidro.Descricao}}</ul></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.AlturaVidro | number: 2}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Largura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.LarguraVidro | number: 2}} metro(s)</span></div></div></div><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Ângulo</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.AnguloVidro}} graus</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Lados Apoiados</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.RelatorioFinal.ApoioVidro}} lados apoiados</span></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=col-xs-12><div class=row ng-if=\"vm.PressaoVentoModel.RelatorioFinal.Vidros && vm.PressaoVentoModel.RelatorioFinal.Vidros.length > 0\"><div class=\"col-xs-12 col-sm-12 col-print-12 form-group vidroEspessuraContent\"><span ng-repeat=\"vidro in vm.PressaoVentoModel.RelatorioFinal.Vidros\" style=\"display: block !important\">{{vm.montarExibicaoVidroAceito(vidro).Descricao}}</span></div></div><div class=row ng-if=\"!vm.PressaoVentoModel.RelatorioFinal.Vidros || vm.PressaoVentoModel.RelatorioFinal.Vidros.length == 0\"><div class=\"col-xs-12 col-print-12 form-group\"><label class=\"control-label pull-left\">Combinação impossível</label></div></div></div></div></div></div><div class=\"row footer\"><div class=col-xs-12 ng-if=\"vm.PressaoVentoModel.RelatorioFinal.ApoioVidro == 2\"><label style=\"color: red !important\">Aplicação de vidros apoiados em 2 lados, a flecha admissível deve ser definida na etapa do projeto e acordado entre as partes.</label></div><div class=col-xs-12 ng-if=\"vm.PressaoVentoModel.PressaoVentoManual == false\">As informações contidas nesse formulário foram baseadas nas normas brasileiras ABNT NBR 7199 e NBR 6123 e são para assistência na aplicação dos vidros CEBRACE, no entanto levam em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, A CEBRACE NÃO SE RESPONSABILIZA POR QUAISQUER ERROS, OMISSÕES OU IMPRECISÕES NAS INFORMAÇÕES PRESTADAS PELO USUÁRIO. Portanto, este documento não deve ser utilizado como memorial de cálculo e sim como uma ferramenta de especificação e auxílio na aplicação de vidros planos CEBRACE. O cliente declara que se responsabilizará perante quaisquer terceiros, por quaisquer atos e fatos oriundos da utilização dos produtos, inclusive no que diz respeito à emissão de ARTs e/ou RRTs quando se tratar de projetos.</div><div class=col-xs-12 ng-if=\"vm.PressaoVentoModel.PressaoVentoManual == true\">As informações contidas nesse formulário foram baseadas nas normas brasileiras ABNT NBR 7199 e pressão de vento inseridas manualmente pelo usuário. Este sistema tem a finalidade de assistência na aplicação dos vidros CEBRACE, no entanto levam em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, A CEBRACE NÃO SE RESPONSABILIZA POR QUAISQUER ERROS, OMISSÕES OU IMPRECISÕES NAS INFORMAÇÕES PRESTADAS PELO USUÁRIO. Portanto, este documento não deve ser utilizado como memorial de cálculo e sim como uma ferramenta de especificação e auxílio na aplicação de vidros planos CEBRACE. O cliente declara que se responsabilizará perante quaisquer terceiros, por quaisquer atos e fatos oriundos da utilização dos produtos, inclusive no que diz respeito à emissão de ARTs e/ou RRTs quando se tratar de projetos.</div><div class=col-xs-12 ng-if=\"vm.PressaoVentoModel.AplicacaoVidroExterno == false\">As informações contidas nesse formulário foram baseadas nas normas brasileiras ABNT NBR 7199 e NBR 6123 e são para assistência na aplicação dos vidros CEBRACE, no entanto levam em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, A CEBRACE NÃO SE RESPONSABILIZA POR QUAISQUER ERROS, OMISSÕES OU IMPRECISÕES NAS INFORMAÇÕES PRESTADAS PELO USUÁRIO. Portanto, este documento não deve ser utilizado como memorial de cálculo e sim como uma ferramenta de especificação e auxílio na aplicação de vidros planos CEBRACE. O cliente declara que se responsabilizará perante quaisquer terceiros, por quaisquer atos e fatos oriundos da utilização dos produtos, inclusive no que diz respeito à emissão de ARTs e/ou RRTs quando se tratar de projetos.</div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.imprimir() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/pressao-vento/passo-a-passo/quarto-passo/quarto-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>10.</h4><p>Informar dados do solicitante para emissão do relatório.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Espessura de Vidro</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-6 form-group\"><label class=control-label>Relatório para</label><input type=text class=form-control ng-model=vm.PressaoVentoModel.Solicitante.Nome></div><div class=\"col-xs-6 form-group\"><label class=control-label>Telefone</label><input type=text class=form-control ng-model=vm.PressaoVentoModel.Solicitante.Telefone ui-br-phone-number></div></div><div class=row><div class=\"col-xs-6 form-group\"><label class=control-label>Empresa</label><input type=text class=form-control ng-model=vm.PressaoVentoModel.Solicitante.Empresa></div><div class=\"col-xs-6 form-group\"><label class=control-label>Fax</label><input type=text class=form-control ng-model=vm.PressaoVentoModel.Solicitante.Fax ui-br-phone-number></div></div><div class=row><div class=\"col-xs-6 form-group\"><label class=control-label>Obra</label><input type=text class=form-control ng-model=vm.PressaoVentoModel.Solicitante.Obra></div><div class=\"col-xs-6 form-group\"><label class=control-label>Email</label><input type=text class=form-control ng-model=vm.PressaoVentoModel.Solicitante.Email></div></div></div></div><div class=row style=\"visibility: hidden;display: none\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados da Região</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Região Selecionada</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.PressaoVentoModel.AplicacaoVidroExterno ? vm.retorno.Regiao : \'Aplicação Interna\'}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Pressão de Calculo</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.PressaoCalculo | number: 2}} Pa</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Pressão Dinâmica</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.PressaoDinamica | number: 2}} Pa</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Pressão do Vento</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.PressaoVento | number: 2}} Pa</span></div></div></div></div></div></div><div class=row style=\"visibility: hidden;display: none\" ng-if=vm.retorno.AlturaEdificio><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados do Edifício</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.AlturaEdificio}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Maior Dimensão</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.MaiorDimensaoEdificio | number: 2}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Menor Dimensao</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.MenorDimensaoEdificio | number: 2}} metro(s)</span></div></div></div></div></div></div><div class=row style=\"visibility: hidden;display: none\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados do Vidro</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Tipo do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><ul ng-repeat=\"vidro in vm.retorno.Vidros | limitTo: 1\" style=\"padding: 0px\"><li>{{vm.pegarPrimeiroNomeVidro(vidro.NomeVidro)}}<ul ng-repeat=\"vidroNvl2 in vidro.Composicao\"><li>{{\'Vidro \' + ($index + 1) + \': \'}}{{vm.pegarPrimeiroNomeVidro(vidroNvl2.NomeVidro)}}<ul ng-repeat=\"vidroNvl3 in vidroNvl2.Composicao\"><li>{{\'Vidro \' + ($parent.$index + 1) + \'.\' + ($index + 1) + \': \'}}{{vm.pegarPrimeiroNomeVidro(vidroNvl3.NomeVidro)}}</li></ul></li></ul></li></ul></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.AlturaVidro | number: 2}} metro(s)</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Largura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.LarguraVidro | number: 2}} metro(s)</span></div></div></div><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Ângulo</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.AnguloVidro}} graus</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Lados Apoiados</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.retorno.ApoioVidro}} lados apoiados</span></div></div></div></div></div></div><div class=row style=\"visibility: hidden;display: none\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=col-xs-12><div class=row ng-if=\"vm.retorno.Vidros && vm.retorno.Vidros.length > 0\"><div class=\"col-xs-12 col-sm-12 col-print-12 form-group vidroEspessuraContent\"><span ng-repeat=\"vidro in vm.retorno.Vidros\" style=\"display: block !important\">{{vm.montarExibicaoVidroAceito(vidro).Descricao}}</span></div></div><div class=row ng-if=\"!vm.retorno.Vidros || vm.retorno.Vidros.length == 0\"><div class=\"col-xs-12 col-print-12 form-group\"><label class=\"control-label pull-left\">Combinação impossível</label></div></div></div></div></div></div><div class=\"row footer\" style=\"visibility: hidden;display: none\"><div class=col-xs-12 ng-if=\"vm.PressaoVentoModel.DadosVidro.Apoio == 2\"><label style=\"color: red !important\">Aplicação de vidros apoiados em 2 lados, a flecha admissível deve ser definida na etapa do projeto e acordado entre as partes.</label></div><div class=col-xs-12>As informações contidas nesse formulário foram baseadas nas normas brasileiras ABNT NBR 7199 e NBR 6123 e são para assistência na aplicação dos vidros CEBRACE, no entanto levam em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, A CEBRACE NÃO SE RESPONSABILIZA POR QUAISQUER ERROS, OMISSÕES OU IMPRECISÕES NAS INFORMAÇÕES PRESTADAS PELO USUÁRIO. Portanto, este documento não deve ser utilizado como memorial de cálculo e sim como uma ferramenta de especificação e auxílio na aplicação de vidros planos CEBRACE. O cliente declara que se responsabilizará perante quaisquer terceiros, por quaisquer atos e fatos oriundos da utilização dos produtos, inclusive no que diz respeito à emissão de ARTs e/ou RRTs quando se tratar de projetos.</div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.calcular() class=\"btn btn-success pull-right\">Calcular</button> <button ng-if=false ng-click=vm.testarImpressao() class=\"btn btn-primary pull-right\">Testar Imprimir</button></div></div></div>");
$templateCache.put("app/view/pressao-vento/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>5.</h4><p>Preencher os campos referentes aos \"Dados da edificação\".</p><p class=text-justify>Caso o vidro seja aplicado em apenas uma região do edifício, indicar no campo “Altura (H1)” a altura onde o vidro será aplicado com relação ao solo.</p></div></div></div><div class=\"row row-eq-height\"><div class=\"col-xs-12 col-sm-6\"><img style=\"width: 600px;max-width: 100%\" src=assets/images/edificacao/edificacao.jpg></div><div class=\"col-xs-12 col-sm-6 vcenter\"><div class=row style=width:100%><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\"><input type=text class=form-control ng-model=vm.PressaoVentoModel.Edificacao.Altura style=\"border-color: grey\" placeholder=\"Altura (H1) em metros\" ng-focus=\"vm.h1Focus=true;\" ng-blur=\"vm.h1Focus=false;\" ui-number-mask=0></div></div><div class=row><div class=\"col-xs-12 form-group\"><input type=text class=form-control ng-model=vm.PressaoVentoModel.Edificacao.MenorDimensao style=\"border-color: grey\" placeholder=\"Menor Dimensão (L1) em metros\" ng-focus=\"vm.l1Focus=true;\" ng-blur=\"vm.l1Focus=false;\" ui-number-mask=0></div></div><div class=row><div class=\"col-xs-12 form-group\"><input type=text class=form-control ng-model=vm.PressaoVentoModel.Edificacao.MaiorDimensao style=\"border-color: grey\" placeholder=\"Maior Dimensão (L2) em metros\" ng-focus=\"vm.l2Focus=true;\" ng-blur=\"vm.l2Focus=false;\" ui-number-mask=0></div></div></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/pressao-vento/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>6.</h4><p>Nos campos referentes aos \"Dados do Vidro\", selecionar o tipo de vidro e preencher as informações quanto a suas dimensões.</p><p class=text-justify>Vale ressaltar que a escolha do tipo de vidro deve estar de acordo com o recomendado no item 4.8 Disposições Construtivas da norma NBR 7199.</p></div></div></div><div class=row><div class=col-xs-12><vidro-dctv composicoes=vm.sourceVidros ao-selecionar-vidro-callback=vm.aoSelecionarVidro></vidro-dctv></div><div class=col-xs-12><div class=row><div class=\"col-xs-6 form-group\"><input type=text ng-model=vm.PressaoVentoModel.DadosVidro.Altura class=form-control placeholder=\"Altura(H) em metros\" ui-number-mask></div><div class=\"col-xs-6 form-group\"><input type=text ng-model=vm.PressaoVentoModel.DadosVidro.Largura class=form-control placeholder=\"Largura(L) em metros\" ui-number-mask></div></div></div></div></div><!-- Fim Dados Vidro!--></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-sm-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>7.</h4><p>Selecionar o número de lados do vidro apoiado.</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-4\" style=\"text-align: center\"><div class=\"cube-apoio disable-hover\"><div class=\"top selected\"></div><div class=\"right selected\"></div><div class=\"bottom selected\"></div><div class=\"left selected\"></div></div><br><label>4 lados</label></div><div class=\"col-xs-12 col-sm-4\" style=\"text-align: center\"><div class=\"cube-apoio disable-hover\"><div class=top></div><div class=\"right selected\"></div><div class=\"bottom selected\"></div><div class=\"left selected\"></div></div><br><label>3 lados</label></div><div class=\"col-xs-12 col-sm-4\" style=\"text-align: center\"><div class=\"cube-apoio disable-hover\"><div class=top></div><div class=\"right selected\"></div><div class=bottom></div><div class=\"left selected\"></div></div><br><label>2 lados</label></div></div><div class=\"col-xs-12 col-sm-offset-3 col-sm-6 form-group\"><ui-select ng-model=vm.PressaoVentoModel.DadosVidro.Apoio><ui-select-match placeholder=Lados><span ng-bind=$select.selected.descricao></span></ui-select-match><ui-select-choices repeat=\"item.valor as item in vm.sourceLados\"><span ng-bind=item.descricao></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>8.</h4><p style=\"margin-bottom: 0px\">Caso exista borda livre, clicar sobre a figura selecionando qual será a orientação da(s) borda(s) livre(s).</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\" style=\"text-align: center\"><div class=\"cube-apoio disable-hover\" ng-class=\"{\'g90\':vm.crudBordaLivre==\'h\'}\"><div class=\"top selected\"></div><div class=\"right selected-vertical\"></div><div class=\"bottom selected\"></div><div class=\"left selected-vertical\"></div></div><br><label>Vertical</label><label ng-if=vm.PressaoVentoModel.DadosVidro.Altura>({{vm.PressaoVentoModel.DadosVidro.Altura | number: 2}} m)</label></div><div class=\"col-xs-12 col-sm-6\" style=\"text-align: center\"><div class=\"cube-apoio disable-hover\" ng-class=\"{\'g90\':vm.crudBordaLivre==\'v\'}\"><div class=\"top selected-horizontal\"></div><div class=\"right selected\"></div><div class=\"bottom selected-horizontal\"></div><div class=\"left selected\"></div></div><br><label>Horizontal</label><label ng-if=vm.PressaoVentoModel.DadosVidro.Altura>({{vm.PressaoVentoModel.DadosVidro.Largura | number: 2}} m)</label></div></div><div class=\"col-xs-12 form-group\"><ui-select ng-model=vm.bordaLivre ng-disabled=\"vm.PressaoVentoModel.DadosVidro.Apoio == 4\"><ui-select-match placeholder=\"{{vm.PressaoVentoModel.DadosVidro.Apoio == 4 ? \'Sem Borda Livre\' : \'Borda Livre\'}}\"><span ng-bind=$select.selected.descricao></span></ui-select-match><ui-select-choices repeat=\"item.valor as item in vm.sourceBordasLivres\"><span ng-bind=item.descricao></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>9.</h4><p>Verificar o ângulo que a peça de vidro forma com a horizontal do prédio preenchendo no campo correspondente o valor positivo do ângulo.</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\" style=\"text-align: center\"><div class=cube-apoio-angulo style=\"height: 20vmin;width: 20vmin\"><div style=\"transform:rotateZ(270deg) translate(-1px, 1%) !important\" id=angulo></div></div><br><label>90º</label></div><div class=\"col-xs-12 col-sm-6\" style=\"text-align: center\"><div class=cube-apoio-angulo style=\"height: 20vmin;width: 20vmin\"><div style=\"transform:rotateZ(315deg) translate(-1px, 1%) !important\" id=angulo></div></div><br><label>45º</label></div></div><div class=row><div class=col-xs-12><input type=text ng-model=vm.PressaoVentoModel.DadosVidro.Angulo placeholder=Ângulo class=form-control ui-number-mask=0></div></div></div></div></div></div><!-- Fim Dados Apoio!--><!-- Fim Dados Vidro - Fim Dados Apoio!--><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/tampo/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-4><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Selecione o tipo de vidro.</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><ui-select ng-model=vm.model.tipoVidro><ui-select-match placeholder=\"Tipo de Vidro\"><span ng-bind=$select.selected.Descricao></span></ui-select-match><ui-select-choices repeat=\"item in vm.sourceTiposVidro\"><span ng-bind=item.Descricao></span></ui-select-choices></ui-select></div></div></div><div class=col-xs-4><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Qual o Tipo do Tampo?</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><button ng-click=\"vm.model.TampoRedondo = false;\" class=\"btn btn-default pull-left\" ng-class=\"!vm.model.TampoRedondo ? \'btn-success\' : \'btn-default\'\" style=\"width: 45%\">Retangular</button> <button ng-click=\"vm.model.TampoRedondo = true;\" class=\"btn btn-default pull-left\" ng-class=\"vm.model.TampoRedondo ? \'btn-success\' : \'btn-default\'\" style=\"width: 45%; float: right !important\">Redondo</button></div></div></div><div class=col-xs-4><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>3.</h4><p>Quais as dimensões da peça?</p></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=!vm.model.TampoRedondo><input type=text ng-model=vm.model.Largura class=form-control placeholder=\"Largura em metros\" ui-number-mask></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=!vm.model.TampoRedondo><input type=text ng-model=vm.model.Comprimento class=form-control placeholder=\"Comprimento em metros\" ui-number-mask></div><div class=\"col-xs-12 form-group\" ng-if=vm.model.TampoRedondo><input type=text ng-model=vm.model.Diametro class=form-control placeholder=\"Diâmetro em metros\" ui-number-mask></div></div><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>4.</h4><p>Superficie toda apoiada?</p></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><button ng-click=\"vm.model.SuperficieTodaApoiada = true;\" class=\"btn btn-default pull-left\" ng-class=\"vm.model.SuperficieTodaApoiada ? \'btn-success\' : \'btn-default\'\" style=\"width: 45%\">Sim</button> <button ng-click=\"vm.model.SuperficieTodaApoiada = false;\" class=\"btn btn-default pull-left\" ng-class=\"!vm.model.SuperficieTodaApoiada ? \'btn-success\' : \'btn-default\'\" style=\"width: 45%; float: right !important\">Não</button></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>5.</h4><p>Altura em relação ao piso.</p></div></div></div><div class=\"col-xs-12 form-group\"><input type=text ng-model=vm.model.AlturaAplicacao class=form-control placeholder=\"Altura em metros\" ui-number-mask ng-disabled=vm.model.SuperficieTodaApoiada></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/tampo/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>6.</h4><p>Informar dados do solicitante para emissão do relatório.</p></div></div></div><div class=\"row print-enabled\"><div class=\"col-xs-12 print-content\"><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-10 col-xs-offset-1 col-sm-10\"><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Relatório para</label><input type=text ng-model=vm.model.Nome class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Telefone</label><input type=text ng-model=vm.model.Telefone class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Empresa</label><input type=text ng-model=vm.model.Empresa class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Fax</label><input type=text ng-model=vm.model.Fax class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Obra</label><input type=text ng-model=vm.model.Obra class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Email</label><input type=text ng-model=vm.model.Email class=form-control></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados Fornecidos</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><img src={{vm.model.TipoVisor.imgSrcSelecionado}} style=\"max-width: 100%\"></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Nome}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Largura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Altura}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura d\'água</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Largura}}</span></div></div></div></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-12\" style=\"overflow-x: scroll\"><table class=\"table table-bordered table-striped\" style=\"max-width: 100%\" wt-responsive-table><thead><tr><th>Tipo de Vidro</th><th>2 Lâminas</th><th>3 Lâminas</th><th>4 Lâminas</th></tr></thead><tbody><tr><td><span>Laminado Comum</span></td><td><span><b>19+19=38 mm</b></span></td><td><span><b>15+15+15=45 mm</b></span></td><td><span><b>12+12+12+12=48 mm</b></span></td></tr><tr><td><span>Laminado Temperado</span></td><td><span><b>10+10=20 mm</b></span></td><td><span><b>8+8+8=24 mm</b></span></td><td><span><b>6+6+6+6=24 mm</b></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.calcular() class=\"btn btn-success pull-right\">Calcular</button></div></div></div>");
$templateCache.put("app/view/tampo/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html","<div id=terceiro-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>7.</h4><p>Resultados obtidos.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Espessura de Vidro</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Dados de Tampo de Vidro</h3></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Relatório para</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Nome}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Telefone</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Telefone | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Empresa</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Empresa}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Fax</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Fax | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Obra</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Obra}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Email</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.Email}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=col-xs-12><div class=col-xs-4><label class=\"control-label pull-left\">Tipo de Vidro:</label><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.tipoVidro.Descricao}}</span></div><div class=col-xs-4 ng-if=!vm.model.TampoRedondo><label class=\"control-label pull-left\">Largura do Vidro:</label><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.Largura | number: 2}} metros</span></div><div class=col-xs-4 ng-if=!vm.model.TampoRedondo><label class=\"control-label pull-left\">Comprimento do Vidro:</label><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.Comprimento | number: 2}} metros</span></div><div class=col-xs-8 ng-if=vm.model.TampoRedondo><label class=\"control-label pull-left\">Diâmetro do Vidro:</label><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.Diametro | number: 2}} metros</span></div><div class=col-xs-4><label class=\"control-label pull-left\">Apoiado em toda superfície?</label><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.SuperficieTodaApoiada ? \'Sim\' : \'Não\'}}</span></div><div class=col-xs-4><label class=\"control-label pull-left\">Altura em relação ao solo:</label><span class=\"control-label pull-left\" style=\"margin-left: 5px\">{{vm.model.AlturaAplicacao | number: 2}} metros</span></div><div class=col-xs-12><label class=\"control-label pull-left\">Espessura Recomendada:</label><span class=\"control-label pull-left\" style=\"margin-left: 5px; font-size: 12px; font-weight: bolder\">{{vm.model.RelatorioFinal | number: 2}} mm</span></div></div></div></div></div><div class=\"row footer\"><div class=col-xs-12><p>Segundo NBR 14488 de 2010, O tampo, pela exigência de uso na estrutura do móvel e pela necessidade ergonômica de uso, requer que os cantos expostos sejam arredondados com um raio mínimo de 5 mm. Os tampos não fabricados com vidros de segurança devem ser apoiados no mínimo em 50% do perímetro e devem estar apoiados em duas regiões diametralmente opostas e distantes no máximo 100 mm da borda.</p><p>Para aplicações onde exista a possibilidade de choque térmico é recomendado o uso de vidro de segurança temperado.</p></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.imprimir() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/visor-piscina/passo-a-passo/primeiro-passo/primeiro-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>1.</h4><p>Selecione o Tipo de Visor.</p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-3 text-center\" ng-repeat=\"visor in vm.sourceVisores\" ng-if=visor.Ativo><small>{{visor.Titulo}}</small> <img style=\"width: 600px;max-width: 100%;height: 200px\" class=img-thumbnail src={{visor.CaminhoImagem}} title={{visor.Descricao}}> <button class=\"btn btn-default\" ng-class=\"{\'btn-success\':visor.selecionado}\" style=\"margin: 5px 0px\" ng-click=vm.selecionarVisor(visor)>Selecionar</button></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"bs-callout bs-callout-cebrace\"><h4>2.</h4><p>Você selecionou <b>{{vm.visorSelecionado().Titulo}}</b>, Preencha os respectivos campos abaixo.</p></div></div></div><div ng-if=fundo4lados><div class=\"col-xs-12 col-sm-3 form-group\"><input type=text ng-model=vm.model.VidroAltura class=form-control placeholder=\"Altura (H)\" ui-number-mask></div><div class=\"col-xs-12 col-sm-3 form-group\"><input type=text ng-model=vm.model.VidroLargura class=form-control placeholder=\"Largura (L) em metros\" ui-number-mask></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=vm.visorSelecionado().NecessarioAlturaAgua><input type=text ng-model=vm.model.AguaAltura class=form-control placeholder=\"Altura Água (h) em metros\" ui-number-mask></div></div><div ng-if=!fundo4lados><div class=\"col-xs-12 col-sm-3 form-group\"><input type=text ng-model=vm.model.VidroAltura class=form-control placeholder=\"Lado 1 em metros\" ui-number-mask></div><div class=\"col-xs-12 col-sm-3 form-group\"><input type=text ng-model=vm.model.VidroLargura class=form-control placeholder=\"Lado 2 em metros\" ui-number-mask></div></div></div><form></form></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.irPassoPosterior() class=\"btn btn-success pull-right\">Próximo</button></div></div></div>");
$templateCache.put("app/view/visor-piscina/passo-a-passo/terceiro-passo/terceiro-passo.tpl.html","<div id=terceiro-passo class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>4.</h4><p>Resultados obtidos.</p></div></div></div><div class=\"row print-enabled\"><div class=container-fluid style=\"visibility: hidden\" style=\"border-bottom: 1px solid #EEEEEE;background-color: #FDFCFC\"><div class=\"row row-header\" style=\"padding: 10px 10px\"><div class=\"col-xs-6 vleft\"><img src=assets/images/logo-cebrace.png style=\"width: 120px\"></div><div class=\"col-xs-6 vright\"><span style=\"font-size: 19px\">Cálculo de Espessura de Vidro</span></div></div></div><div class=\"col-xs-12 print-content\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\" style=\"text-align: center\"><h3 class=print-ignore>Dados do Relatório</h3><h3 class=print-only>Dados de Piscina/Aquário e Vidro</h3></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Relatório para</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Nome}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Telefone</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Telefone | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Empresa</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Empresa}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Fax</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Fax | numeroTelefone}}</span></div></div><div class=row><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Obra</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Obra}}</span></div><div class=\"col-xs-6 col-sm-2 col-print-2 form-group\"><label class=control-label>Email</label></div><div class=\"col-xs-6 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Email}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Dados</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-print-12\"><img style=\"width: 400px;max-width: 100%;height: 200px;display: block !important; margin: 0 auto\" class=img-thumbnail src={{vm.model.RelatorioFinal.CaminhoImagem}}></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.AlturaVidro | number: 2}} metros</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Largura do Vidro</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.LarguraVidro | number: 2}} metros</span></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Altura da Água</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.AlturaAgua | number: 2}} metros</span></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Considerado</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Taxa de trabalho admissível a flexão</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.TaxaTrabalhoAdmissivel | number: 2}} kg/cm³</span></div></div><div class=row><div class=col-xs-12><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.TextoApoio}}</span></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><label class=\"control-label pull-left\">Área da Peça</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.AreaVidro | number: 2}} m²</span></div></div><div class=row><div class=\"col-xs-5 col-sm-5 col-print-5 form-group\"><label class=\"control-label pull-left\">Vidro / Resultados</label></div><div class=\"col-xs-4 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-left\">Espessura Recomendada</label></div><div class=\"col-xs-3 col-sm-3 col-print-3 form-group\"><label class=\"control-label pull-left\">Peso do Vidro</label></div></div><div class=row ng-repeat=\"espessura in vm.model.RelatorioFinal.Espessuras\"><div class=\"col-xs-5 col-sm-5 col-print-5 form-group\"><span class=\"control-label pull-left\">{{espessura.Vidro}}</span></div><div class=\"col-xs-4 col-sm-4 col-print-4 form-group\"><span class=\"control-label pull-left\">{{espessura.EspessuraRecomendada | number: 2}} mm</span></div><div class=\"col-xs-3 col-sm-3 col-print-3 form-group\"><span class=\"control-label pull-left\">{{espessura.Peso | number: 2}} kg</span></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group title\"><h3>Observação</h3></div></div><div class=row><div class=col-xs-12><span class=\"control-label pull-left\">{{vm.model.RelatorioFinal.Observacao}}</span></div></div></div></div><div class=\"row footer\"><div class=col-xs-12 ng-if=false><!--<label style=\"color: red !important;\">Aplicação de vidros apoiados em 2 lados, a flecha admissível deve ser definida na etapa do projeto e acordado entre as partes.</label>--></div><div class=col-xs-12>O cálculo de espessura de vidros para visores de piscina, não contempla o cálculo de flecha admissível, que deve ser definida na etapa do projeto e acordado entre as partes. As informações contidas nesse são para assistência na aplicação dos vidros CEBRACE, no entanto levam em consideração as informações prestadas pelo usuário, sendo este o único responsável pelas mesmas. Neste sentido, A CEBRACE NÃO SE RESPONSABILIZA POR QUAISQUER ERROS, OMISSÕES OU IMPRECISÕES NAS INFORMAÇÕES PRESTADAS PELO USUÁRIO. Portanto, este documento não deve ser utilizado como memorial de cálculo e sim como uma ferramenta de especificação e auxílio na aplicação de vidros planos CEBRACE. O cliente declara que se responsabilizará perante quaisquer terceiros, por quaisquer atos e fatos oriundos da utilização dos produtos, inclusive no que diz respeito à emissão de ARTs e/ou RRTs quando se tratar de projetos</div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.imprimir() class=\"btn btn-primary pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/view/visor-piscina/passo-a-passo/segundo-passo/segundo-passo.tpl.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=\"bs-callout bs-callout-cebrace\"><h4>3.</h4><p>Informar dados do solicitante para emissão do relatório.</p></div></div></div><div class=\"row print-enabled\"><div class=\"col-xs-12 print-content\"><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados da Edificação e Vidro</h3></div></div><div class=row><div class=\"col-xs-10 col-xs-offset-1 col-sm-10\"><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Relatório para</label><input type=text ng-model=vm.model.Nome class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Telefone</label><input type=text ng-model=vm.model.Telefone class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Empresa</label><input type=text ng-model=vm.model.Empresa class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Fax</label><input type=text ng-model=vm.model.Fax class=form-control ui-br-phone-number></div></div><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Obra</label><input type=text ng-model=vm.model.Obra class=form-control></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=control-label>Email</label><input type=text ng-model=vm.model.Email class=form-control></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Dados Fornecidos</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><img src={{vm.model.TipoVisor.imgSrcSelecionado}} style=\"max-width: 100%\"></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Nome}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Largura</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Altura}}</span></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-print-4 form-group\"><label class=\"control-label pull-right\">Altura d\'água</label></div><div class=\"col-xs-12 col-sm-6 col-print-6 form-group\"><span class=\"control-label pull-right\">{{vm.crudCalculoEspessura.Dados.Vidro.Largura}}</span></div></div></div></div></div></div></div><div class=row style=\"visibility: hidden\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-12 form-group\" style=\"border-bottom: 1px solid #ddd\"><h3>Resultado do Calculo</h3></div></div><div class=row><div class=\"col-xs-12 col-sm-12\" style=\"overflow-x: scroll\"><table class=\"table table-bordered table-striped\" style=\"max-width: 100%\" wt-responsive-table><thead><tr><th>Tipo de Vidro</th><th>2 Lâminas</th><th>3 Lâminas</th><th>4 Lâminas</th></tr></thead><tbody><tr><td><span>Laminado Comum</span></td><td><span><b>19+19=38 mm</b></span></td><td><span><b>15+15+15=45 mm</b></span></td><td><span><b>12+12+12+12=48 mm</b></span></td></tr><tr><td><span>Laminado Temperado</span></td><td><span><b>10+10=20 mm</b></span></td><td><span><b>8+8+8=24 mm</b></span></td><td><span><b>6+6+6+6=24 mm</b></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=col-xs-12 style=\"margin:20px 0px;text-align: center\"><button ng-click=vm.irPassoAnterior() class=\"btn btn-success pull-left\">Voltar</button> <button ng-click=vm.calcular() class=\"btn btn-success pull-right\">Calcular</button></div></div></div>");}]);